const translations = {
  en: {
    app_name: 'Spiritual Gems',
    home: 'Home',
    bible: 'Bible',
    search: 'Search',
    search_placeholder: 'Search gems, bookmarks, notes...',
    search_empty_message: 'Search for gems by keyword or verse reference',
    profile: 'Profile',
    welcome_title: 'Spiritual Gems & Preaching Reports',
    welcome_subtitle: 'Share spiritual insights and explore the Holy Scriptures together',
    enter_app: 'Enter App',
    select_language: 'Select Language',
    create_gem: 'Share a Gem',
    gem_placeholder: 'Share a spiritual insight...',
    verse_ref_placeholder: 'Gem Reference',
    gem_text_label: 'Gem Text',
    gem_text_placeholder: 'The verse or quote text...',
    insight_label: 'Your Insight',
    insight_placeholder: 'Share your personal reflection...',
    post: 'Post',
    sort_newest: 'Newest',
    sort_oldest: 'Oldest',
    sort_most_liked: 'Most Liked',
    liked_gems: 'Liked Gems',
    cancel: 'Cancel',
    like: 'Like',
    share: 'Share',
    report: 'Report',
    delete: 'Delete',
    translate: 'Translate',
    report_confirm: 'Are you sure you want to report this gem?',
    delete_confirm: 'Are you sure you want to delete this gem?',
    yes: 'Yes',
    no: 'No',
    no_gems: 'No gems yet. Be the first to share!',
    loading: 'Loading...',
    bible_reader: 'Bible Reader',
    open_bible: 'Open Bible',
    audio: 'Audio',
    bookmarks: 'Bookmarks',
    notes: 'Notes',
    gems: 'Gems',
    settings: 'Settings',
    theme: 'Theme',
    font_size: 'Font Size',
    dark_mode: 'Dark Mode',
    light_mode: 'Light Mode',
    donate: 'Donate',
    suggest: 'Suggest a Modification',
    about: 'About',
    admin: 'Admin',
    admin_password: 'Admin Password',
    reported_gems: 'Reported Gems',
    copied: 'Copied to clipboard',
    gem_posted: 'Gem posted!',
    gem_deleted: 'Gem deleted',
    gem_reported: 'Gem reported. Thank you.',
    share_via: 'Share via',
    copy_text: 'Copy Text',
    open_translate: 'Open in Google Translate',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    extra_large: 'Extra Large',
    language: 'Language',
    about_nwt: 'About the New World Translation',
    about_text: 'The New World Translation of the Holy Scriptures (2018 Revision) is renowned for its accuracy, clarity, and use of modern language. It faithfully restores God\'s name, Jehovah, in the thousands of places where it originally appeared in the Hebrew and Greek manuscripts. This translation uses clear, natural language that makes the Bible accessible to people of all backgrounds, while maintaining fidelity to the original texts.',
    about_title: 'New World Translation\nof the Holy Scriptures',
    about_subtitle: '2018 Revision',
    about_accuracy_title: 'Accuracy & Faithfulness',
    about_accuracy_text: 'The New World Translation was produced by a committee of dedicated scholars who prioritized faithfulness to the original Hebrew, Aramaic, and Greek texts. Unlike many translations that follow tradition over textual accuracy, the NWT consistently renders God\'s personal name, Jehovah (YHWH), in the nearly 7,000 places where it appeared in the original manuscripts.',
    about_clarity_title: 'Clarity & Modern Language',
    about_clarity_text: 'The 2018 revision updated the language to be more natural and easier to understand while maintaining accuracy. Archaic expressions were replaced with modern equivalents, making the Scriptures more accessible to contemporary readers without sacrificing the depth and beauty of the original text.',
    about_gods_name_title: 'Use of God\'s Name',
    about_gods_name_text: 'One of the most distinctive features of the NWT is its consistent use of the divine name Jehovah. While many translations have removed or replaced God\'s personal name with titles like "LORD," the NWT restores it to its rightful place, allowing readers to develop a more personal relationship with the Author of the Bible.',
    about_languages_title: 'Available in Many Languages',
    about_languages_text: 'The New World Translation is available in whole or in part in over 200 languages, making it one of the most widely translated Bibles in the world. This app provides access to the NWT in 10 languages, with both text and audio formats.',
    about_learn_more: 'Learn more at',
    bible_navigation: 'Bible Navigation',
    fullscreen: 'Fullscreen',
    exit_fullscreen: 'Exit',
    translating: 'Translating...',
    see_original: 'See original',
    see_translation: 'See translation',
    translation_error: 'Translation failed',
    search_bible: 'Search Bible',
    search_placeholder: 'Enter a word or phrase...',
    searching: 'Searching entire Bible...',
    no_results: 'No results found',
    no_results_current_page: 'No results on current page. Navigate and try again.',
    results_found: 'results found',
    search_error: 'Search failed',
    add_bookmark: 'Bookmark',
    add_note: 'Note',
    // Messaging
    send_message: 'Send message',
    messages: 'Messages',
    new_message: 'New message',
    type_message: 'Type a message...',
    no_messages: 'No messages yet',
    message_sent: 'Message sent',
    accept_messages: 'Accept private messages',
    messages_disabled: 'This user has disabled private messages',
    login_to_message: 'Please log in to send messages',
    cannot_message_self: "You can't message yourself",
    // Notifications
    notifications: 'Notifications',
    no_notifications: 'No notifications yet',
    mark_all_read: 'Mark all read',
    new_comment_notification: 'New comment on your gem',
    new_message_notification: 'New message',
    messages_encrypted: 'Messages are end-to-end encrypted',
    // Profile
    profile_photo: 'Profile photo',
    change_photo: 'Change photo',
    remove_photo: 'Remove photo',
    take_photo: 'Take Photo',
    choose_from_gallery: 'Choose from Gallery',
    adjust_photo: 'Adjust Photo',
    drag_to_position: 'Use arrows to position',
    center: 'Center',
    guest_mode: 'Guest Mode',
    sign_in_prompt: 'Sign in to personalize your experience',
    logout: 'Logout',
    save_changes: 'Save Changes',
    profile_updated: 'Profile updated!',
    photo_removed: 'Photo removed',
    admin_access_granted: 'Admin access granted',
    login: 'Login',
    register: 'Register',
    login_to_post: 'Please log in to post',
    share_preaching: 'Share a report',
    preaching: 'Preaching',
    new_report: 'New Report',
    no_reports: 'No reports yet',
    report_posted: 'Report posted!',
    report_deleted: 'Report deleted',
    preaching_notes_placeholder: 'Share your experience...',
    date: 'Date',
    all: 'All',
    cat_presentoir: 'Display',
    cat_porte_a_porte: 'Door to door',
    cat_rue: 'Street',
    cat_telephone: 'Phone',
    cat_courrier: 'Letter',
    cat_informel: 'Informal',
    cookie_title: 'Cookies & Privacy',
    cookie_message: 'We use cookies for ads and analytics. You can accept personalized ads or choose non-personalized ads only.',
    cookie_accept: 'Accept',
    cookie_decline: 'Non-personalized only',
    ad_loading_title: 'Loading your personalized experience...',
    ad_loading_subtitle: 'Preparing content in your language',
    ad_revenue: 'Ad Revenue (est.)',
    ad_revenue_history: 'Monthly Ad Revenue',
    scroll_down_audio: 'Scroll down to see the audio player',
    // Comments
    edit: 'Edit',
    save: 'Save',
    comment_updated: 'Comment updated',
    comment_update_failed: 'Failed to update comment',
    comment_deleted: 'Comment deleted',
    comment_delete_failed: 'Failed to delete comment',
    delete_comment_confirm: 'Are you sure you want to delete this comment?',
    // Privacy & Security
    privacy_policy: 'Privacy & Security',
    encrypted: 'Encrypted',
    privacy_subtitle: 'Security & Data Protection',
    privacy_intro_title: 'Your Privacy Matters',
    privacy_intro_content: 'Spiritual Gems is committed to protecting your privacy and securing your personal data. This policy explains how we collect, use, and protect your information.',
    privacy_data_title: 'Data We Collect',
    privacy_data_1: 'Account information (username, pseudonym)',
    privacy_data_2: 'Profile photo (optional)',
    privacy_data_3: 'Spiritual Gems you post and comments',
    privacy_data_4: 'Private messages (encrypted)',
    privacy_data_5: 'Bible bookmarks and notes',
    privacy_data_6: 'App preferences (language, theme)',
    privacy_data_7: 'Push notification preferences',
    privacy_advantages_title: 'Message Security',
    security_auth_title: 'Authentication Security',
    security_username_only: 'Username-Only Registration',
    security_username_only_desc: 'No email address is required. Your privacy is maximized with username-only accounts. Usernames are validated (3-20 alphanumeric characters).',
    security_encryption_rest: 'Encryption at Rest (AES-256-GCM)',
    security_encryption_rest_desc: 'All private messages are encrypted before being stored in our database. Even if the database is compromised, messages remain unreadable without the encryption key.',
    security_e2e: 'End-to-End Encryption (X25519 + NaCl)',
    security_e2e_desc: "Messages are encrypted in your browser before being sent. The server stores only the encrypted payload and cannot read your messages.",
    security_zero_knowledge: 'Zero-Knowledge Architecture',
    security_zero_knowledge_desc: 'Your private encryption key is generated and stored exclusively in your browser (IndexedDB). It is NEVER sent to or stored on our server.',
    security_rate_limit: 'Rate Limiting',
    security_rate_limit_desc: 'Limited to 10 messages per minute to prevent spam and abuse. Admin login is also rate-limited to prevent brute-force attacks.',
    security_xss: 'XSS Protection',
    security_xss_desc: 'All user input (messages, gems, comments) is sanitized to prevent cross-site scripting attacks. Malicious scripts are automatically stripped.',
    security_input_validation: 'Input Validation',
    security_input_validation_desc: 'All user content is length-limited and sanitized. Gems are limited to 2000 characters, comments to 1000 characters.',
    security_expiration: 'Message Expiration',
    security_expiration_desc: 'Messages automatically delete after 30 days. You can also manually delete your messages at any time.',
    security_https: 'HTTPS Only',
    security_https_desc: 'All data transmission is encrypted using TLS/SSL. Your data is protected in transit.',
    security_ddos: 'DDoS Protection',
    security_ddos_desc: 'Multi-layer protection: progressive slowdown at 80 req/min, hard block at 120 req/min, auto-ban at 300 req/min. Heavy endpoints limited to 10 req/min. Security headers prevent clickjacking and MIME attacks.',
    security_password: 'Secure Password Storage (Argon2id)',
    security_password_desc: 'All passwords (users and admin) are hashed using Argon2id with a unique salt per entry. Argon2id is the winner of the Password Hashing Competition, resistant to GPU and ASIC attacks.',
    security_jwt: 'JWT Authentication',
    security_jwt_desc: 'Secure token-based authentication with 72-hour expiration. Tokens are signed and verified on each request.',
    security_pfs: 'Perfect Forward Secrecy (PFS)',
    security_pfs_desc: 'Each message uses a unique ephemeral X25519 key pair. Even if your long-term private key is compromised, past and future conversations remain fully protected.',
    security_key_separation: 'Client-Side Key Storage',
    security_key_separation_desc: 'Private keys are stored in your browser IndexedDB, never on the server. Only the public key is shared for message routing.',
    security_argon2: 'Argon2id Hashing',
    security_argon2_desc: 'Administrative passwords are protected with Argon2id — the winner of the Password Hashing Competition. It is resistant to GPU and ASIC attacks.',
    security_secure_translation: 'Secure Translation Pipeline',
    security_secure_translation_desc: 'When translating messages, plaintext exists only in server RAM (volatile memory). It is never logged, cached to disk, or written to any file.',
    security_notifications_title: 'Push Notifications',
    security_notif_browser: 'Browser Notifications',
    security_notif_browser_desc: 'You can enable browser push notifications for new messages and comments on your gems. Permission is requested only once and can be revoked at any time in your browser settings.',
    security_notif_sound: 'Notification Sounds & Vibration',
    security_notif_sound_desc: 'A gentle two-tone chime and vibration pattern alert you on mobile devices. These only trigger when new notifications arrive, not on initial page load.',
    security_notif_data: 'Notification Data',
    security_notif_data_desc: 'Notifications are stored server-side and linked to your user ID. They contain sender name and a brief description, but not message content.',
    privacy_limitations_title: 'Security Limitations',
    limitation_server: 'Translation Requires Temporary Plaintext',
    limitation_server_desc: 'To translate messages, the client sends decrypted text to the server temporarily (RAM-only, No-Trace). The server cannot proactively decrypt messages.',
    limitation_metadata: 'Metadata Visibility',
    limitation_metadata_desc: 'We can see who messages whom and when (metadata), but not the content. Message timestamps, sender/recipient IDs are not encrypted.',
    limitation_backup: 'Database Backups',
    limitation_backup_desc: 'Database backups may contain encrypted messages. Old backups could persist after you delete messages.',
    limitation_device: 'Device Security',
    limitation_device_desc: 'If your device is compromised, attackers could see decrypted messages on your screen. We cannot protect against device-level attacks.',
    limitation_social: 'Social Engineering',
    limitation_social_desc: 'We cannot protect against phishing or social engineering attacks. Never share your password with anyone.',
    privacy_rights_title: 'Your Rights',
    privacy_rights_1: 'Access your personal data at any time',
    privacy_rights_2: 'Delete your messages and content',
    privacy_rights_3: 'Update or correct your profile information',
    privacy_rights_4: 'Disable private messaging to stop receiving messages',
    privacy_rights_5: 'Request account deletion (contact us)',
    privacy_rights_6: 'Control push notification permissions in your browser',
    privacy_retention_title: 'Data Retention',
    privacy_retention_content: 'Private messages are automatically deleted after 30 days. Notifications are kept until read or cleared. Spiritual Gems and comments are kept until you delete them. Account data is retained until you request account deletion.',
    privacy_third_party_title: 'Third-Party Services',
    privacy_third_party_1: 'Microsoft Azure Translator (optional, for auto-translation)',
    privacy_third_party_2: 'JW.org (Bible content and audio)',
    privacy_third_party_3: 'PayPal (donation processing, external link)',
    privacy_third_party_note: 'Donations are processed externally via PayPal; Spiritual Gems never sees or stores your financial data. Azure translations follow a strict No-Trace policy — content exists only in RAM and is never logged.',
    security_enabled: 'Zero-Knowledge Architecture',
    security_badge_desc: 'X25519 + PFS + AES-256-GCM + Argon2id',
    security_at_a_glance: 'Security at a Glance',
    glance_no_email: 'No Email Required',
    glance_no_email_desc: 'Total privacy — username-only accounts',
    glance_encryption: 'Zero-Knowledge Encryption',
    glance_encryption_desc: 'X25519 + NaCl — keys stay in your browser',
    glance_auto_delete: 'Auto-Deletion',
    glance_auto_delete_desc: 'Messages vanish after 30 days',
    // Install & Admin Stats
    add_to_homescreen: 'Add to Home Screen',
    available: 'Available',
    app_installed: 'App added to home screen!',
    install_ios: 'Tap the Share button, then "Add to Home Screen"',
    install_manual: 'Open browser menu and tap "Add to Home Screen"',
    admin_stats: 'Statistics',
    visitors_this_month: 'Visitors this month',
    chars_translated: 'Chars translated',
    requests: 'requests',
    visitor_history: 'Monthly Visitors',
    translation_history: 'Monthly Translation (chars)',
    reported_gems: 'Reported Gems',
    reported_comments: 'Comments',
    // Toast & UI messages
    bookmark_added: 'Bookmark added!',
    bookmark_deleted: 'Bookmark deleted',
    note_saved: 'Note saved!',
    note_deleted: 'Note deleted',
    comment_added: 'Comment added!',
    comment_reported: 'Comment reported',
    gem_deleted_admin: 'Gem deleted by admin',
    messages_enabled: 'Messages enabled',
    messages_disabled_toast: 'Messages disabled',
    password_changed: 'Password changed successfully',
    password_change_failed: 'Failed to change password',
    account_deleted: 'Account deleted',
    account_delete_failed: 'Failed to delete account',
    auth_failed: 'Authentication failed',
    update_failed: 'Update failed',
    image_too_large: 'Image must be less than 2MB',
    invalid_password: 'Invalid password',
    search_failed: 'Search failed',
    search_unavailable: 'Unable to search',
    bible_not_available: 'Bible not available',
    bible_not_available_desc: 'The Bible is not yet available in this language on jw.org. Please select another language.',
    loading_bible: 'Loading Bible...',
    loading_first_time: 'First load may take a few seconds',
    audio_bible: 'Audio Bible',
    select_book: 'Select Book',
    choose_book: 'Choose a book...',
    select_chapter: 'Select Chapter',
    choose_chapter: 'Choose a chapter...',
    books_available: 'books',
    audio_chapters: 'audio chapters',
    bookmark_label_placeholder: 'Bookmark label (e.g. Genesis 1:1)',
    verse_ref_placeholder: 'Verse reference (optional)',
    note_placeholder: 'Your note...',
    error: 'Failed',
    failed_load_gems: 'Failed to load gems',
    failed_load_audio: 'Failed to load audio',
    failed_load_comments: 'Failed to load comments',
    failed_load_conversations: 'Failed to load conversations',
    failed_load_messages: 'Failed to load messages',
    failed_load_reported: 'Failed to load reported content',
    failed_load_stats: 'Failed to load statistics',
    failed_add_bookmark: 'Failed to add bookmark',
    failed_add_comment: 'Failed to add comment',
    failed_delete: 'Failed to delete',
    failed_delete_gem: 'Failed to delete gem',
    failed_delete_bookmark: 'Failed to delete bookmark',
    failed_delete_note: 'Failed to delete note',
    failed_save_note: 'Failed to save note',
    failed_update_like: 'Failed to update like',
    failed_update_photo: 'Failed to update photo',
    failed_update_settings: 'Failed to update settings',
    failed_remove_photo: 'Failed to remove photo',
    failed_report: 'Failed to report',
    failed_report_comment: 'Failed to report comment',
    failed_like_comment: 'Failed to like comment',
    // Account management
    change_password: 'Change Password',
    current_password: 'Current password',
    new_password: 'New password (min 6 chars)',
    delete_account: 'Delete Account',
    delete_account_warning: 'This will permanently delete your account, messages, gems, and all data. This action cannot be undone.',
    confirm_password: 'Enter password to confirm',
    confirm_delete_account: 'Permanently Delete Account',
    search_users: 'Search users...',
    start_conversation_hint: "Click on a user's name to start a conversation",
    privacy_last_updated: 'Last updated',
    privacy_contact: 'Questions? Use "Suggest a modification" to contact us.',
    // Auth
    username: 'Username',
    password: 'Password',
    username_hint: 'Choose a unique username (3-20 characters)',
    login_success: 'Logged in successfully!',
    register_success: 'Account created!',
    create_account: 'Create Account',
  },
  es: {
    app_name: 'Perlas Espirituales',
    home: 'Inicio',
    bible: 'Biblia',
    search: 'Buscar',
    search_placeholder: 'Buscar perlas, favoritos, notas...',
    search_empty_message: 'Buscar perlas por palabra clave o referencia de versículo',
    profile: 'Perfil',
    welcome_title: 'Perlas Espirituales y Hechos de Predicación',
    welcome_subtitle: 'Comparte ideas espirituales y explora las Sagradas Escrituras juntos',
    enter_app: 'Entrar',
    select_language: 'Seleccionar idioma',
    create_gem: 'Compartir una Perla',
    gem_placeholder: 'Comparte una idea espiritual...',
    verse_ref_placeholder: 'Referencia de la Perla',
    gem_text_label: 'Texto de la Perla',
    gem_text_placeholder: 'El versículo o cita...',
    insight_label: 'Tu reflexión',
    insight_placeholder: 'Comparte tu reflexión personal...',
    post: 'Publicar',
    sort_newest: 'Recientes',
    sort_oldest: 'Antiguas',
    sort_most_liked: 'Más gustadas',
    liked_gems: 'Perlas gustadas',
    cancel: 'Cancelar',
    like: 'Me gusta',
    share: 'Compartir',
    report: 'Reportar',
    delete: 'Eliminar',
    translate: 'Traducir',
    report_confirm: '¿Seguro que quieres reportar esta perla?',
    delete_confirm: '¿Seguro que quieres eliminar esta perla?',
    yes: 'Sí',
    no: 'No',
    no_gems: 'Aún no hay perlas. ¡Sé el primero en compartir!',
    loading: 'Cargando...',
    bible_reader: 'Lector de la Biblia',
    open_bible: 'Abrir Biblia',
    audio: 'Audio',
    bookmarks: 'Marcadores',
    notes: 'Notas',
    gems: 'Perlas',
    settings: 'Configuración',
    theme: 'Tema',
    font_size: 'Tamaño de fuente',
    dark_mode: 'Modo oscuro',
    light_mode: 'Modo claro',
    donate: 'Donar',
    suggest: 'Sugerir una modificación',
    about: 'Acerca de',
    admin: 'Administrador',
    admin_password: 'Contraseña de admin',
    reported_gems: 'Perlas reportadas',
    copied: 'Copiado al portapapeles',
    gem_posted: '¡Perla publicada!',
    gem_deleted: 'Perla eliminada',
    gem_reported: 'Perla reportada. Gracias.',
    share_via: 'Compartir por',
    copy_text: 'Copiar texto',
    open_translate: 'Abrir en Google Translate',
    small: 'Pequeño',
    medium: 'Mediano',
    large: 'Grande',
    extra_large: 'Extra grande',
    language: 'Idioma',
    about_nwt: 'Acerca de la Traducción del Nuevo Mundo',
    about_text: 'La Traducción del Nuevo Mundo de las Santas Escrituras (Revisión 2018) es reconocida por su precisión, claridad y uso del lenguaje moderno.',
    about_title: 'Traducción del Nuevo Mundo\nde las Santas Escrituras',
    about_subtitle: 'Revisión de 2018',
    about_accuracy_title: 'Precisión y fidelidad',
    about_accuracy_text: 'La Traducción del Nuevo Mundo fue producida por un comité de eruditos dedicados que priorizaron la fidelidad a los textos originales en hebreo, arameo y griego. A diferencia de muchas traducciones que siguen la tradición por encima de la precisión textual, la TNM traduce consistentemente el nombre personal de Dios, Jehová (YHWH), en los casi 7.000 lugares donde aparecía en los manuscritos originales.',
    about_clarity_title: 'Claridad y lenguaje moderno',
    about_clarity_text: 'La revisión de 2018 actualizó el lenguaje para que fuera más natural y fácil de entender, manteniendo la precisión. Las expresiones arcaicas fueron reemplazadas por equivalentes modernos, haciendo las Escrituras más accesibles para los lectores contemporáneos sin sacrificar la profundidad y belleza del texto original.',
    about_gods_name_title: 'El uso del nombre de Dios',
    about_gods_name_text: 'Una de las características más distintivas de la TNM es el uso consistente del nombre divino Jehová. Mientras que muchas traducciones han eliminado o reemplazado el nombre personal de Dios con títulos como "SEÑOR", la TNM lo restaura a su lugar legítimo, permitiendo a los lectores desarrollar una relación más personal con el Autor de la Biblia.',
    about_languages_title: 'Disponible en muchos idiomas',
    about_languages_text: 'La Traducción del Nuevo Mundo está disponible total o parcialmente en más de 200 idiomas, lo que la convierte en una de las Biblias más ampliamente traducidas del mundo. Esta aplicación proporciona acceso a la TNM en 10 idiomas, con formatos de texto y audio.',
    about_learn_more: 'Más información en',
    bible_navigation: 'Navegación de la Biblia',
    fullscreen: 'Pantalla completa',
    exit_fullscreen: 'Salir',
    translating: 'Traduciendo...',
    see_original: 'Ver original',
    see_translation: 'Ver traducción',
    translation_error: 'Error de traducción',
    search_bible: 'Buscar en la Biblia',
    searching: 'Buscando en toda la Biblia...',
    no_results: 'Sin resultados',
    results_found: 'resultados encontrados',
    search_error: 'Error de búsqueda',
    add_bookmark: 'Marcador',
    add_note: 'Nota',
    send_message: 'Enviar mensaje',
    messages: 'Mensajes',
    new_message: 'Nuevo mensaje',
    type_message: 'Escribe un mensaje...',
    no_messages: 'No hay mensajes',
    message_sent: 'Mensaje enviado',
    accept_messages: 'Aceptar mensajes privados',
    messages_disabled: 'Este usuario ha desactivado los mensajes privados',
    notifications: 'Notificaciones',
    no_notifications: 'No hay notificaciones',
    mark_all_read: 'Marcar todo leído',
    messages_encrypted: 'Los mensajes están cifrados de extremo a extremo',
    profile_photo: 'Foto de perfil',
    change_photo: 'Cambiar foto',
    remove_photo: 'Eliminar foto',
    take_photo: 'Tomar foto',
    choose_from_gallery: 'Elegir de galería',
    adjust_photo: 'Ajustar foto',
    drag_to_position: 'Usa las flechas para posicionar',
    center: 'Centrar',
    guest_mode: 'Modo invitado',
    sign_in_prompt: 'Inicia sesión para personalizar tu experiencia',
    logout: 'Cerrar sesión',
    save_changes: 'Guardar cambios',
    profile_updated: 'Perfil actualizado',
    photo_removed: 'Foto eliminada',
    admin_access_granted: 'Acceso de administrador concedido',
    login: 'Iniciar sesión',
    register: 'Registrarse',
    login_to_post: 'Inicia sesión para publicar',
    share_preaching: 'Compartir un informe',
    preaching: 'Predicación',
    new_report: 'Nuevo informe',
    no_reports: 'Sin informes',
    report_posted: 'Informe publicado',
    report_deleted: 'Informe eliminado',
    preaching_notes_placeholder: 'Comparte tu experiencia...',
    date: 'Fecha',
    all: 'Todo',
    cat_presentoir: 'Exhibidor',
    cat_porte_a_porte: 'Puerta a puerta',
    cat_rue: 'Calle',
    cat_telephone: 'Teléfono',
    cat_courrier: 'Carta',
    cat_informel: 'Informal',
    cookie_title: 'Cookies y privacidad',
    cookie_message: 'Usamos cookies para anuncios y análisis. Puede aceptar anuncios personalizados o elegir solo no personalizados.',
    cookie_accept: 'Aceptar',
    cookie_decline: 'Solo no personalizados',
    ad_loading_title: 'Cargando tu experiencia personalizada...',
    ad_loading_subtitle: 'Preparando contenido en tu idioma',
    ad_revenue: 'Ingresos publicitarios (est.)',
    ad_revenue_history: 'Ingresos publicitarios mensuales',
    scroll_down_audio: 'Desplázate hacia abajo para ver el reproductor',
    loading_bible: 'Cargando la Biblia...',
    loading_first_time: 'La primera carga puede tardar unos segundos',
    security_ddos: 'Protección DDoS',
    security_ddos_desc: 'Protección multicapa: ralentización a 80 req/min, bloqueo a 120 req/min, prohibición automática a 300 req/min.',
    // Bible Audio
    audio_bible: 'Biblia en Audio',
    select_book: 'Seleccionar Libro',
    choose_book: 'Elige un libro...',
    select_chapter: 'Seleccionar Capítulo',
    choose_chapter: 'Elige un capítulo...',
    books_available: 'libros',
    audio_chapters: 'capítulos de audio',
    bookmark_label_placeholder: 'Etiqueta (ej. Génesis 1:1)',
    verse_ref_placeholder: 'Referencia bíblica (opcional)',
    note_placeholder: 'Tu nota...',
    bible_not_available: 'Biblia no disponible',
    bible_not_available_desc: 'La Biblia aún no está disponible en este idioma en jw.org.',
    // Toast & UI messages
    bookmark_added: 'Marcador agregado',
    bookmark_deleted: 'Marcador eliminado',
    note_saved: 'Nota guardada',
    note_deleted: 'Nota eliminada',
    comment_added: 'Comentario agregado',
    comment_reported: 'Comentario reportado',
    gem_deleted_admin: 'Gema eliminada por admin',
    messages_enabled: 'Mensajes activados',
    messages_disabled_toast: 'Mensajes desactivados',
    password_changed: 'Contraseña cambiada',
    password_change_failed: 'Error al cambiar contraseña',
    account_deleted: 'Cuenta eliminada',
    account_delete_failed: 'Error al eliminar cuenta',
    auth_failed: 'Error de autenticación',
    update_failed: 'Error de actualización',
    image_too_large: 'La imagen debe ser menor de 2MB',
    invalid_password: 'Contraseña inválida',
    search_failed: 'Error de búsqueda',
    search_unavailable: 'Búsqueda no disponible',
    error: 'Error',
    failed_load_gems: 'Error al cargar gemas',
    failed_load_audio: 'Error al cargar audio',
    failed_load_comments: 'Error al cargar comentarios',
    failed_load_conversations: 'Error al cargar conversaciones',
    failed_load_messages: 'Error al cargar mensajes',
    failed_load_reported: 'Error al cargar reportados',
    failed_load_stats: 'Error al cargar estadísticas',
    failed_add_bookmark: 'Error al agregar marcador',
    failed_add_comment: 'Error al agregar comentario',
    failed_delete: 'Error al eliminar',
    failed_delete_gem: 'Error al eliminar gema',
    failed_delete_bookmark: 'Error al eliminar marcador',
    failed_delete_note: 'Error al eliminar nota',
    failed_save_note: 'Error al guardar nota',
    failed_update_like: 'Error al actualizar',
    failed_update_photo: 'Error al actualizar foto',
    failed_update_settings: 'Error al actualizar ajustes',
    failed_remove_photo: 'Error al eliminar foto',
    failed_report: 'Error al reportar',
    failed_report_comment: 'Error al reportar comentario',
    failed_like_comment: 'Error al dar me gusta',
    change_password: 'Cambiar contraseña',
    current_password: 'Contraseña actual',
    new_password: 'Nueva contraseña (mín. 6 caracteres)',
    delete_account: 'Eliminar cuenta',
    delete_account_warning: 'Esto eliminará permanentemente tu cuenta y todos los datos.',
    confirm_password: 'Ingresa tu contraseña para confirmar',
    confirm_delete_account: 'Eliminar cuenta permanentemente',
    search_users: 'Buscar usuarios...',
    start_conversation_hint: 'Haz clic en un nombre para iniciar una conversación',
    // Privacy & Security
    privacy_policy: 'Privacidad y Seguridad',
    encrypted: 'Cifrado',
    privacy_subtitle: 'Seguridad y Protección de Datos',
    privacy_intro_title: 'Tu Privacidad Importa',
    privacy_intro_content: 'Spiritual Gems se compromete a proteger tu privacidad y asegurar tus datos personales. Esta política explica cómo recopilamos, usamos y protegemos tu información.',
    privacy_data_title: 'Datos que Recopilamos',
    privacy_data_1: 'Información de cuenta (nombre de usuario, seudónimo)',
    privacy_data_2: 'Foto de perfil (opcional)',
    privacy_data_3: 'Perlas espirituales y comentarios',
    privacy_data_4: 'Mensajes privados (cifrados)',
    privacy_data_5: 'Marcadores y notas de la Biblia',
    privacy_data_6: 'Preferencias de la app (idioma, tema)',
    privacy_data_7: 'Preferencias de notificaciones',
    privacy_advantages_title: 'Seguridad de Mensajes',
    security_auth_title: 'Seguridad de Autenticación',
    security_username_only: 'Registro solo con nombre de usuario',
    security_username_only_desc: 'No se requiere correo electrónico. Tu privacidad se maximiza con cuentas solo de nombre de usuario.',
    security_encryption_rest: 'Cifrado en Reposo (AES-256-GCM)',
    security_encryption_rest_desc: 'Todos los mensajes privados se cifran antes de almacenarse.',
    security_e2e: 'Cifrado de Extremo a Extremo (X25519 + AES-256-GCM)',
    security_e2e_desc: 'Los mensajes se cifran con la clave pública del destinatario.',
    security_rate_limit: 'Limitación de Velocidad',
    security_rate_limit_desc: 'Limitado a 10 mensajes por minuto. El acceso de administrador también tiene límite.',
    security_xss: 'Protección XSS',
    security_xss_desc: 'Toda entrada se desinfecta para prevenir ataques de scripts.',
    security_input_validation: 'Validación de Entrada',
    security_input_validation_desc: 'Todo contenido está limitado en longitud y desinfectado.',
    security_expiration: 'Expiración de Mensajes',
    security_expiration_desc: 'Los mensajes se eliminan automáticamente después de 30 días.',
    security_https: 'Solo HTTPS',
    security_https_desc: 'Toda transmisión se cifra usando TLS/SSL.',
    security_password: 'Almacenamiento Seguro de Contraseñas',
    security_password_desc: 'Las contraseñas se cifran con bcrypt.',
    security_jwt: 'Autenticación JWT',
    security_jwt_desc: 'Autenticación basada en tokens con expiración de 72 horas.',
    security_notifications_title: 'Notificaciones Push',
    security_notif_browser: 'Notificaciones del Navegador',
    security_notif_browser_desc: 'Puedes activar notificaciones push para nuevos mensajes y comentarios.',
    security_notif_sound: 'Sonidos y Vibración',
    security_notif_sound_desc: 'Un timbre suave y vibración te alertan en dispositivos móviles.',
    security_notif_data: 'Datos de Notificación',
    security_notif_data_desc: 'Las notificaciones no contienen contenido de mensajes cifrados.',
    privacy_limitations_title: 'Limitaciones de Seguridad',
    limitation_server: 'Acceso del Servidor',
    limitation_server_desc: 'Los administradores podrían teóricamente descifrar mensajes.',
    limitation_metadata: 'Visibilidad de Metadatos',
    limitation_metadata_desc: 'Podemos ver quién envía mensajes a quién, pero no el contenido.',
    limitation_backup: 'Copias de Seguridad',
    limitation_backup_desc: 'Las copias pueden contener mensajes cifrados.',
    limitation_device: 'Seguridad del Dispositivo',
    limitation_device_desc: 'Si tu dispositivo está comprometido, podrían ver mensajes.',
    limitation_social: 'Ingeniería Social',
    limitation_social_desc: 'Nunca compartas tu contraseña con nadie.',
    privacy_rights_title: 'Tus Derechos',
    privacy_rights_1: 'Acceder a tus datos personales',
    privacy_rights_2: 'Eliminar tus mensajes y contenido',
    privacy_rights_3: 'Actualizar tu perfil',
    privacy_rights_4: 'Desactivar mensajes privados',
    privacy_rights_5: 'Solicitar eliminación de cuenta',
    privacy_rights_6: 'Controlar permisos de notificaciones',
    privacy_retention_title: 'Retención de Datos',
    privacy_retention_content: 'Los mensajes se eliminan después de 30 días. Las notificaciones se conservan hasta leerse.',
    privacy_third_party_title: 'Servicios de Terceros',
    privacy_third_party_1: 'Microsoft Azure Translator (opcional)',
    privacy_third_party_2: 'JW.org (contenido bíblico)',
    privacy_third_party_3: 'PayPal (donaciones)',
    privacy_third_party_note: 'No vendemos tus datos a terceros.',
    security_enabled: 'Seguridad Mejorada Activada',
    security_badge_desc: 'AES-256 + RSA-2048 + Protección XSS',
    privacy_last_updated: 'Última actualización',
    privacy_contact: '¿Preguntas? Usa "Sugerir una modificación".',
  },
  fr: {
    app_name: 'Perles Spirituelles',
    home: 'Accueil',
    bible: 'Bible',
    search: 'Rechercher',
    search_placeholder: 'Rechercher perles, favoris, notes...',
    search_empty_message: 'Rechercher des perles par mot-clé ou référence de verset',
    profile: 'Profil',
    welcome_title: 'Perles Spirituelles et Faits de Prédication',
    welcome_subtitle: 'Partagez des idées spirituelles et explorez les Saintes Écritures ensemble',
    enter_app: 'Entrer',
    select_language: 'Choisir la langue',
    create_gem: 'Partager une Perle',
    gem_placeholder: 'Partagez une idée spirituelle...',
    verse_ref_placeholder: 'Référence de la Perle',
    gem_text_label: 'Texte de la Perle',
    gem_text_placeholder: 'Le verset ou la citation...',
    insight_label: 'Votre réflexion',
    insight_placeholder: 'Partagez votre réflexion personnelle...',
    post: 'Publier',
    sort_newest: 'Récentes',
    sort_oldest: 'Anciennes',
    sort_most_liked: 'Plus aimées',
    liked_gems: 'Perles aimées',
    cancel: 'Annuler',
    like: "J'aime",
    share: 'Partager',
    report: 'Signaler',
    delete: 'Supprimer',
    translate: 'Traduire',
    report_confirm: 'Êtes-vous sûr de vouloir signaler cette perle?',
    delete_confirm: 'Êtes-vous sûr de vouloir supprimer cette perle?',
    yes: 'Oui',
    no: 'Non',
    no_gems: 'Pas encore de perles. Soyez le premier à partager!',
    loading: 'Chargement...',
    bible_reader: 'Lecteur de la Bible',
    open_bible: 'Ouvrir la Bible',
    audio: 'Audio',
    bookmarks: 'Signets',
    notes: 'Notes',
    gems: 'Perles',
    settings: 'Paramètres',
    theme: 'Thème',
    font_size: 'Taille de police',
    dark_mode: 'Mode sombre',
    light_mode: 'Mode clair',
    donate: 'Faire un don',
    suggest: 'Suggérer une modification',
    about: 'À propos',
    admin: 'Administrateur',
    admin_password: 'Mot de passe admin',
    reported_gems: 'Perles signalées',
    copied: 'Copié dans le presse-papiers',
    gem_posted: 'Perle publiée!',
    gem_deleted: 'Perle supprimée',
    gem_reported: 'Perle signalée. Merci.',
    share_via: 'Partager via',
    copy_text: 'Copier le texte',
    open_translate: 'Ouvrir dans Google Translate',
    small: 'Petit',
    medium: 'Moyen',
    large: 'Grand',
    extra_large: 'Très grand',
    language: 'Langue',
    about_nwt: 'À propos de la Traduction du monde nouveau',
    about_text: "La Traduction du monde nouveau des Saintes Écritures (révision de 2018) est reconnue pour sa précision, sa clarté et l'utilisation d'un langage moderne.",
    about_title: 'Traduction du monde nouveau\ndes Saintes Écritures',
    about_subtitle: 'Révision de 2018',
    about_accuracy_title: 'Précision et fidélité',
    about_accuracy_text: "La Traduction du monde nouveau a été produite par un comité d'érudits dévoués qui ont donné la priorité à la fidélité aux textes originaux en hébreu, en araméen et en grec. Contrairement à de nombreuses traductions qui suivent la tradition plutôt que la précision textuelle, la TMN traduit systématiquement le nom personnel de Dieu, Jéhovah (YHWH), dans les quelque 7 000 endroits où il apparaissait dans les manuscrits originaux.",
    about_clarity_title: 'Clarté et langage moderne',
    about_clarity_text: "La révision de 2018 a mis à jour le langage pour le rendre plus naturel et plus facile à comprendre tout en maintenant la précision. Les expressions archaïques ont été remplacées par des équivalents modernes, rendant les Écritures plus accessibles aux lecteurs contemporains sans sacrifier la profondeur et la beauté du texte original.",
    about_gods_name_title: "L'emploi du nom de Dieu",
    about_gods_name_text: "L'une des caractéristiques les plus distinctives de la TMN est l'emploi systématique du nom divin Jéhovah. Alors que de nombreuses traductions ont supprimé ou remplacé le nom personnel de Dieu par des titres comme « SEIGNEUR », la TMN le rétablit à sa juste place, permettant aux lecteurs de développer une relation plus personnelle avec l'Auteur de la Bible.",
    about_languages_title: 'Disponible en de nombreuses langues',
    about_languages_text: "La Traduction du monde nouveau est disponible en tout ou en partie dans plus de 200 langues, ce qui en fait l'une des Bibles les plus largement traduites au monde. Cette application donne accès à la TMN en 10 langues, avec des formats texte et audio.",
    about_learn_more: 'En savoir plus sur',
    bible_navigation: 'Navigation biblique',
    fullscreen: 'Plein écran',
    exit_fullscreen: 'Quitter',
    translating: 'Traduction en cours...',
    see_original: 'Voir l\'original',
    see_translation: 'Voir la traduction',
    translation_error: 'Erreur de traduction',
    search_bible: 'Rechercher dans la Bible',
    searching: 'Recherche dans toute la Bible...',
    no_results: 'Aucun résultat',
    results_found: 'résultats trouvés',
    search_error: 'Erreur de recherche',
    add_bookmark: 'Signet',
    add_note: 'Note',
    send_message: 'Envoyer un message',
    messages: 'Messages',
    new_message: 'Nouveau message',
    type_message: 'Écrivez un message...',
    no_messages: 'Aucun message',
    message_sent: 'Message envoyé',
    accept_messages: 'Accepter les messages privés',
    messages_disabled: 'Cet utilisateur a désactivé les messages privés',
    notifications: 'Notifications',
    no_notifications: 'Aucune notification',
    mark_all_read: 'Tout marquer comme lu',
    messages_encrypted: 'Les messages sont chiffrés de bout en bout',
    profile_photo: 'Photo de profil',
    change_photo: 'Changer la photo',
    remove_photo: 'Supprimer la photo',
    take_photo: 'Prendre une photo',
    choose_from_gallery: 'Choisir dans la galerie',
    adjust_photo: 'Ajuster la photo',
    drag_to_position: 'Utilisez les flèches pour positionner',
    center: 'Centrer',
    guest_mode: 'Mode invité',
    sign_in_prompt: 'Connectez-vous pour personnaliser votre expérience',
    logout: 'Déconnexion',
    save_changes: 'Enregistrer',
    profile_updated: 'Profil mis à jour',
    photo_removed: 'Photo supprimée',
    admin_access_granted: 'Accès administrateur accordé',
    login: 'Connexion',
    register: "S'inscrire",
    login_to_post: 'Connectez-vous pour publier',
    share_preaching: 'Partager un fait',
    preaching: 'Prédication',
    new_report: 'Nouveau rapport',
    no_reports: 'Aucun rapport',
    report_posted: 'Rapport publié !',
    report_deleted: 'Rapport supprimé',
    preaching_notes_placeholder: 'Partagez votre expérience...',
    date: 'Date',
    all: 'Tout',
    cat_presentoir: 'Présentoir',
    cat_porte_a_porte: 'Porte à porte',
    cat_rue: 'Rue',
    cat_telephone: 'Téléphone',
    cat_courrier: 'Courrier',
    cat_informel: 'Informel',
    cookie_title: 'Cookies et confidentialité',
    cookie_message: 'Nous utilisons des cookies pour la publicité et les statistiques. Vous pouvez accepter les annonces personnalisées ou choisir uniquement les non personnalisées.',
    cookie_accept: 'Accepter',
    cookie_decline: 'Non personnalisées uniquement',
    ad_loading_title: 'Chargement de votre expérience personnalisée...',
    ad_loading_subtitle: 'Préparation du contenu dans votre langue',
    ad_revenue: 'Revenus publicitaires (est.)',
    ad_revenue_history: 'Revenus publicitaires mensuels',
    scroll_down_audio: 'Faites défiler vers le bas pour voir le lecteur audio',
    loading_bible: 'Chargement de la Bible...',
    loading_first_time: 'Le premier chargement peut prendre quelques secondes',
    security_ddos: 'Protection DDoS',
    security_ddos_desc: 'Protection multicouche : ralentissement à 80 req/min, blocage à 120 req/min, bannissement automatique à 300 req/min.',
    // Bible Audio
    audio_bible: 'Bible Audio',
    select_book: 'Sélectionner un Livre',
    choose_book: 'Choisir un livre...',
    select_chapter: 'Sélectionner un Chapitre',
    choose_chapter: 'Choisir un chapitre...',
    books_available: 'livres',
    audio_chapters: 'chapitres audio',
    bookmark_label_placeholder: 'Étiquette (ex. Genèse 1:1)',
    verse_ref_placeholder: 'Référence biblique (optionnel)',
    note_placeholder: 'Votre note...',
    bible_not_available: 'Bible non disponible',
    bible_not_available_desc: 'La Bible n\'est pas encore disponible dans cette langue sur jw.org.',
    // Toast & UI messages
    bookmark_added: 'Signet ajouté',
    bookmark_deleted: 'Signet supprimé',
    note_saved: 'Note enregistrée',
    note_deleted: 'Note supprimée',
    comment_added: 'Commentaire ajouté',
    comment_reported: 'Commentaire signalé',
    gem_deleted_admin: 'Perle supprimée par admin',
    messages_enabled: 'Messages activés',
    messages_disabled_toast: 'Messages désactivés',
    password_changed: 'Mot de passe changé',
    password_change_failed: 'Échec du changement de mot de passe',
    account_deleted: 'Compte supprimé',
    account_delete_failed: 'Échec de la suppression du compte',
    auth_failed: 'Erreur d\'authentification',
    update_failed: 'Échec de la mise à jour',
    image_too_large: 'L\'image doit faire moins de 2 Mo',
    invalid_password: 'Mot de passe invalide',
    search_failed: 'Échec de la recherche',
    search_unavailable: 'Recherche indisponible',
    error: 'Erreur',
    failed_load_gems: 'Échec du chargement des perles',
    failed_load_audio: 'Échec du chargement audio',
    failed_load_comments: 'Échec du chargement des commentaires',
    failed_load_conversations: 'Échec du chargement des conversations',
    failed_load_messages: 'Échec du chargement des messages',
    failed_load_reported: 'Échec du chargement du contenu signalé',
    failed_load_stats: 'Échec du chargement des statistiques',
    failed_add_bookmark: 'Échec de l\'ajout du signet',
    failed_add_comment: 'Échec de l\'ajout du commentaire',
    failed_delete: 'Échec de la suppression',
    failed_delete_gem: 'Échec de la suppression de la perle',
    failed_delete_bookmark: 'Échec de la suppression du signet',
    failed_delete_note: 'Échec de la suppression de la note',
    failed_save_note: 'Échec de l\'enregistrement de la note',
    failed_update_like: 'Échec de la mise à jour',
    failed_update_photo: 'Échec de la mise à jour de la photo',
    failed_update_settings: 'Échec de la mise à jour des paramètres',
    failed_remove_photo: 'Échec de la suppression de la photo',
    failed_report: 'Échec du signalement',
    failed_report_comment: 'Échec du signalement du commentaire',
    failed_like_comment: 'Échec du j\'aime',
    change_password: 'Changer le mot de passe',
    current_password: 'Mot de passe actuel',
    new_password: 'Nouveau mot de passe (min. 6 caractères)',
    delete_account: 'Supprimer le compte',
    delete_account_warning: 'Cela supprimera définitivement votre compte et toutes vos données.',
    confirm_password: 'Entrez votre mot de passe pour confirmer',
    confirm_delete_account: 'Supprimer définitivement le compte',
    search_users: 'Rechercher des utilisateurs...',
    start_conversation_hint: 'Cliquez sur un nom pour démarrer une conversation',
    // Privacy & Security
    privacy_policy: 'Confidentialité et Sécurité',
    encrypted: 'Chiffré',
    privacy_subtitle: 'Sécurité et Protection des Données',
    privacy_intro_title: 'Votre Vie Privée Compte',
    privacy_intro_content: 'Spiritual Gems s\'engage à protéger votre vie privée et à sécuriser vos données personnelles.',
    privacy_data_title: 'Données Collectées',
    privacy_data_1: 'Informations de compte (nom d\'utilisateur, pseudonyme)',
    privacy_data_2: 'Photo de profil (optionnelle)',
    privacy_data_3: 'Perles spirituelles et commentaires',
    privacy_data_4: 'Messages privés (chiffrés)',
    privacy_data_5: 'Signets et notes bibliques',
    privacy_data_6: 'Préférences (langue, thème)',
    privacy_data_7: 'Préférences de notifications',
    privacy_advantages_title: 'Sécurité des Messages',
    security_auth_title: 'Sécurité d\'Authentification',
    security_username_only: 'Inscription par nom d\'utilisateur uniquement',
    security_username_only_desc: 'Aucun e-mail requis. Votre vie privée est maximisée.',
    security_encryption_rest: 'Chiffrement au Repos (AES-256-GCM)',
    security_encryption_rest_desc: 'Tous les messages sont chiffrés avant stockage.',
    security_e2e: 'Chiffrement de Bout en Bout (X25519 + AES-256-GCM)',
    security_e2e_desc: 'Les messages sont chiffrés avec la clé publique du destinataire.',
    security_rate_limit: 'Limitation de Débit',
    security_rate_limit_desc: 'Limité à 10 messages par minute contre le spam.',
    security_xss: 'Protection XSS',
    security_xss_desc: 'Toutes les entrées sont nettoyées contre les scripts malveillants.',
    security_input_validation: 'Validation des Entrées',
    security_input_validation_desc: 'Tout le contenu est limité en longueur et nettoyé.',
    security_expiration: 'Expiration des Messages',
    security_expiration_desc: 'Les messages sont supprimés après 30 jours.',
    security_https: 'HTTPS Uniquement',
    security_https_desc: 'Toute transmission est chiffrée via TLS/SSL.',
    security_password: 'Stockage Sécurisé des Mots de Passe',
    security_password_desc: 'Les mots de passe sont hachés avec bcrypt.',
    security_jwt: 'Authentification JWT',
    security_jwt_desc: 'Authentification par jetons avec expiration de 72 heures.',
    security_notifications_title: 'Notifications Push',
    security_notif_browser: 'Notifications Navigateur',
    security_notif_browser_desc: 'Activez les notifications pour les nouveaux messages et commentaires.',
    security_notif_sound: 'Sons et Vibration',
    security_notif_sound_desc: 'Un carillon doux et une vibration vous alertent sur mobile.',
    security_notif_data: 'Données de Notification',
    security_notif_data_desc: 'Les notifications ne contiennent pas le contenu des messages.',
    privacy_limitations_title: 'Limitations de Sécurité',
    limitation_server: 'Accès Serveur',
    limitation_server_desc: 'Les administrateurs pourraient théoriquement déchiffrer les messages.',
    limitation_metadata: 'Visibilité des Métadonnées',
    limitation_metadata_desc: 'Nous voyons qui envoie à qui, mais pas le contenu.',
    limitation_backup: 'Sauvegardes',
    limitation_backup_desc: 'Les sauvegardes peuvent contenir des messages chiffrés.',
    limitation_device: 'Sécurité de l\'Appareil',
    limitation_device_desc: 'Un appareil compromis pourrait révéler les messages.',
    limitation_social: 'Ingénierie Sociale',
    limitation_social_desc: 'Ne partagez jamais votre mot de passe.',
    privacy_rights_title: 'Vos Droits',
    privacy_rights_1: 'Accéder à vos données personnelles',
    privacy_rights_2: 'Supprimer vos messages et contenu',
    privacy_rights_3: 'Mettre à jour votre profil',
    privacy_rights_4: 'Désactiver les messages privés',
    privacy_rights_5: 'Demander la suppression du compte',
    privacy_rights_6: 'Contrôler les permissions de notifications',
    privacy_retention_title: 'Conservation des Données',
    privacy_retention_content: 'Les messages sont supprimés après 30 jours. Les notifications sont conservées jusqu\'à lecture.',
    privacy_third_party_title: 'Services Tiers',
    privacy_third_party_1: 'Microsoft Azure Translator (optionnel)',
    privacy_third_party_2: 'JW.org (contenu biblique)',
    privacy_third_party_3: 'PayPal (dons)',
    privacy_third_party_note: 'Nous ne vendons pas vos données.',
    security_enabled: 'Sécurité Renforcée Activée',
    security_badge_desc: 'AES-256 + RSA-2048 + Protection XSS',
    privacy_last_updated: 'Dernière mise à jour',
    privacy_contact: 'Questions ? Utilisez « Suggérer une modification ».',
  },
  de: {
    app_name: 'Geistliche Perlen',
    home: 'Startseite',
    bible: 'Bibel',
    search: 'Suchen',
    search_placeholder: 'Perlen, Lesezeichen, Notizen suchen...',
    search_empty_message: 'Nach Perlen nach Stichwort oder Versreferenz suchen',
    profile: 'Profil',
    welcome_title: 'Geistliche Perlen und Predigtberichte',
    welcome_subtitle: 'Teile geistliche Einsichten und erkunde die Heilige Schrift gemeinsam',
    enter_app: 'Eintreten',
    select_language: 'Sprache wählen',
    create_gem: 'Eine Perle teilen',
    gem_placeholder: 'Teile eine geistliche Einsicht...',
    verse_ref_placeholder: 'Perlen-Referenz',
    gem_text_label: 'Perlentext',
    gem_text_placeholder: 'Der Bibelvers oder das Zitat...',
    insight_label: 'Deine Einsicht',
    insight_placeholder: 'Teile deine persönliche Betrachtung...',
    post: 'Veröffentlichen',
    sort_newest: 'Neueste',
    sort_oldest: 'Älteste',
    sort_most_liked: 'Beliebteste',
    liked_gems: 'Beliebte Perlen',
    cancel: 'Abbrechen',
    like: 'Gefällt mir',
    share: 'Teilen',
    report: 'Melden',
    delete: 'Löschen',
    translate: 'Übersetzen',
    report_confirm: 'Bist du sicher, dass du diese Perle melden möchtest?',
    delete_confirm: 'Bist du sicher, dass du diese Perle löschen möchtest?',
    yes: 'Ja',
    no: 'Nein',
    no_gems: 'Noch keine Perlen. Sei der Erste, der teilt!',
    loading: 'Laden...',
    bible_reader: 'Bibelleser',
    open_bible: 'Bibel öffnen',
    audio: 'Audio',
    bookmarks: 'Lesezeichen',
    notes: 'Notizen',
    gems: 'Perlen',
    settings: 'Einstellungen',
    theme: 'Thema',
    font_size: 'Schriftgröße',
    dark_mode: 'Dunkler Modus',
    light_mode: 'Heller Modus',
    donate: 'Spenden',
    suggest: 'Änderung vorschlagen',
    about: 'Über',
    admin: 'Administrator',
    admin_password: 'Admin-Passwort',
    reported_gems: 'Gemeldete Perlen',
    copied: 'In die Zwischenablage kopiert',
    gem_posted: 'Perle veröffentlicht!',
    gem_deleted: 'Perle gelöscht',
    gem_reported: 'Perle gemeldet. Danke.',
    share_via: 'Teilen über',
    copy_text: 'Text kopieren',
    open_translate: 'In Google Translate öffnen',
    small: 'Klein',
    medium: 'Mittel',
    large: 'Groß',
    extra_large: 'Sehr groß',
    language: 'Sprache',
    about_nwt: 'Über die Neue-Welt-Übersetzung',
    about_text: 'Die Neue-Welt-Übersetzung der Heiligen Schrift (Revision 2018) ist bekannt für ihre Genauigkeit, Klarheit und den Gebrauch moderner Sprache.',
    about_title: 'Neue-Welt-Übersetzung\nder Heiligen Schrift',
    about_subtitle: 'Revision 2018',
    about_accuracy_title: 'Genauigkeit und Treue',
    about_accuracy_text: 'Die Neue-Welt-Übersetzung wurde von einem Komitee engagierter Gelehrter erstellt, die der Treue zum hebräischen, aramäischen und griechischen Urtext Vorrang einräumten. Im Gegensatz zu vielen Übersetzungen, die eher der Tradition als der Textgenauigkeit folgen, gibt die NWÜ konsequent Gottes persönlichen Namen Jehova (JHWH) an den fast 7.000 Stellen wieder, an denen er in den Originalmanuskripten erschien.',
    about_clarity_title: 'Klarheit und moderne Sprache',
    about_clarity_text: 'Die Revision von 2018 hat die Sprache aktualisiert, um sie natürlicher und leichter verständlich zu machen, ohne dabei an Genauigkeit einzubüßen. Veraltete Ausdrücke wurden durch moderne Entsprechungen ersetzt, wodurch die Heilige Schrift für heutige Leser zugänglicher wird, ohne die Tiefe und Schönheit des Originaltextes zu opfern.',
    about_gods_name_title: 'Gebrauch des Namens Gottes',
    about_gods_name_text: 'Eines der markantesten Merkmale der NWÜ ist der konsequente Gebrauch des göttlichen Namens Jehova. Während viele Übersetzungen Gottes persönlichen Namen entfernt oder durch Titel wie „HERR" ersetzt haben, stellt die NWÜ ihn an seinen rechtmäßigen Platz zurück und ermöglicht es den Lesern, eine persönlichere Beziehung zum Autor der Bibel aufzubauen.',
    about_languages_title: 'In vielen Sprachen verfügbar',
    about_languages_text: 'Die Neue-Welt-Übersetzung ist ganz oder teilweise in über 200 Sprachen verfügbar und damit eine der am weitesten verbreiteten Bibelübersetzungen der Welt. Diese App bietet Zugang zur NWÜ in 10 Sprachen mit Text- und Audioformaten.',
    about_learn_more: 'Mehr erfahren auf',
    bible_navigation: 'Bibelnavigation',
    fullscreen: 'Vollbild',
    exit_fullscreen: 'Beenden',
    translating: 'Übersetzen...',
    see_original: 'Original anzeigen',
    see_translation: 'Übersetzung anzeigen',
    translation_error: 'Übersetzungsfehler',
    search_bible: 'Bibel durchsuchen',
    searching: 'Suche in der gesamten Bibel...',
    no_results: 'Keine Ergebnisse',
    results_found: 'Ergebnisse gefunden',
    search_error: 'Suchfehler',
    add_bookmark: 'Lesezeichen',
    add_note: 'Notiz',
    send_message: 'Nachricht senden',
    messages: 'Nachrichten',
    new_message: 'Neue Nachricht',
    type_message: 'Nachricht eingeben...',
    no_messages: 'Keine Nachrichten',
    message_sent: 'Nachricht gesendet',
    accept_messages: 'Private Nachrichten akzeptieren',
    messages_disabled: 'Dieser Benutzer hat private Nachrichten deaktiviert',
    notifications: 'Benachrichtigungen',
    no_notifications: 'Keine Benachrichtigungen',
    mark_all_read: 'Alle als gelesen markieren',
    messages_encrypted: 'Nachrichten sind Ende-zu-Ende-verschlüsselt',
    profile_photo: 'Profilfoto',
    change_photo: 'Foto ändern',
    remove_photo: 'Foto entfernen',
    take_photo: 'Foto aufnehmen',
    choose_from_gallery: 'Aus Galerie wählen',
    adjust_photo: 'Foto anpassen',
    drag_to_position: 'Pfeile zur Positionierung verwenden',
    center: 'Zentrieren',
    guest_mode: 'Gastmodus',
    sign_in_prompt: 'Melden Sie sich an, um Ihre Erfahrung zu personalisieren',
    logout: 'Abmelden',
    save_changes: 'Änderungen speichern',
    profile_updated: 'Profil aktualisiert',
    photo_removed: 'Foto entfernt',
    admin_access_granted: 'Administratorzugang gewährt',
    login: 'Anmelden',
    register: 'Registrieren',
    login_to_post: 'Bitte einloggen zum Posten',
    share_preaching: 'Bericht teilen',
    preaching: 'Predigtdienst',
    new_report: 'Neuer Bericht',
    no_reports: 'Keine Berichte',
    report_posted: 'Bericht veröffentlicht',
    report_deleted: 'Bericht gelöscht',
    preaching_notes_placeholder: 'Teile deine Erfahrung...',
    date: 'Datum',
    all: 'Alle',
    cat_presentoir: 'Infostand',
    cat_porte_a_porte: 'Haus-zu-Haus',
    cat_rue: 'Straße',
    cat_telephone: 'Telefon',
    cat_courrier: 'Brief',
    cat_informel: 'Informell',
    cookie_title: 'Cookies & Datenschutz',
    cookie_message: 'Wir verwenden Cookies für Werbung und Analysen.',
    cookie_accept: 'Akzeptieren',
    cookie_decline: 'Nur nicht personalisiert',
    ad_loading_title: 'Laden Ihrer personalisierten Erfahrung...',
    ad_loading_subtitle: 'Inhalte in Ihrer Sprache werden vorbereitet',
    ad_revenue: 'Werbeeinnahmen (gesch.)',
    ad_revenue_history: 'Monatliche Werbeeinnahmen',
    scroll_down_audio: 'Scrollen Sie nach unten zum Audio-Player',
    loading_bible: 'Bibel wird geladen...',
    loading_first_time: 'Das erste Laden kann einige Sekunden dauern',
    security_ddos: 'DDoS-Schutz',
    security_ddos_desc: 'Mehrstufiger Schutz: Verlangsamung ab 80 Req/Min, Blockierung ab 120, Bann ab 300 Req/Min.',
    // Bible Audio
    audio_bible: 'Audio-Bibel',
    select_book: 'Buch auswählen',
    choose_book: 'Buch wählen...',
    select_chapter: 'Kapitel auswählen',
    choose_chapter: 'Kapitel wählen...',
    books_available: 'Bücher',
    audio_chapters: 'Audio-Kapitel',
    bookmark_label_placeholder: 'Bezeichnung (z.B. 1. Mose 1:1)',
    verse_ref_placeholder: 'Bibelstelle (optional)',
    note_placeholder: 'Ihre Notiz...',
    bible_not_available: 'Bibel nicht verfügbar',
    bible_not_available_desc: 'Die Bibel ist in dieser Sprache auf jw.org noch nicht verfügbar.',
    // Toast & UI messages
    bookmark_added: 'Lesezeichen hinzugefügt',
    bookmark_deleted: 'Lesezeichen gelöscht',
    note_saved: 'Notiz gespeichert',
    note_deleted: 'Notiz gelöscht',
    comment_added: 'Kommentar hinzugefügt',
    comment_reported: 'Kommentar gemeldet',
    gem_deleted_admin: 'Perle vom Admin gelöscht',
    messages_enabled: 'Nachrichten aktiviert',
    messages_disabled_toast: 'Nachrichten deaktiviert',
    password_changed: 'Passwort geändert',
    password_change_failed: 'Passwortänderung fehlgeschlagen',
    account_deleted: 'Konto gelöscht',
    account_delete_failed: 'Kontolöschung fehlgeschlagen',
    auth_failed: 'Authentifizierung fehlgeschlagen',
    update_failed: 'Aktualisierung fehlgeschlagen',
    image_too_large: 'Bild muss kleiner als 2 MB sein',
    invalid_password: 'Ungültiges Passwort',
    search_failed: 'Suche fehlgeschlagen',
    search_unavailable: 'Suche nicht verfügbar',
    error: 'Fehler',
    failed_load_gems: 'Fehler beim Laden',
    failed_load_audio: 'Fehler beim Laden des Audios',
    failed_load_comments: 'Fehler beim Laden der Kommentare',
    failed_load_conversations: 'Fehler beim Laden',
    failed_load_messages: 'Fehler beim Laden der Nachrichten',
    failed_load_reported: 'Fehler beim Laden',
    failed_load_stats: 'Fehler beim Laden der Statistiken',
    failed_add_bookmark: 'Fehler beim Hinzufügen',
    failed_add_comment: 'Fehler beim Hinzufügen',
    failed_delete: 'Fehler beim Löschen',
    failed_delete_gem: 'Fehler beim Löschen',
    failed_delete_bookmark: 'Fehler beim Löschen',
    failed_delete_note: 'Fehler beim Löschen',
    failed_save_note: 'Fehler beim Speichern',
    failed_update_like: 'Fehler',
    failed_update_photo: 'Fehler beim Aktualisieren',
    failed_update_settings: 'Fehler beim Aktualisieren',
    failed_remove_photo: 'Fehler beim Entfernen',
    failed_report: 'Fehler beim Melden',
    failed_report_comment: 'Fehler beim Melden',
    failed_like_comment: 'Fehler',
    change_password: 'Passwort ändern',
    current_password: 'Aktuelles Passwort',
    new_password: 'Neues Passwort (min. 6 Zeichen)',
    delete_account: 'Konto löschen',
    delete_account_warning: 'Dies löscht Ihr Konto und alle Daten dauerhaft.',
    confirm_password: 'Passwort zur Bestätigung eingeben',
    confirm_delete_account: 'Konto dauerhaft löschen',
    search_users: 'Benutzer suchen...',
    start_conversation_hint: 'Klicke auf einen Namen, um eine Unterhaltung zu starten',
    // Privacy & Security
    privacy_policy: 'Datenschutz & Sicherheit',
    encrypted: 'Verschlüsselt',
    privacy_subtitle: 'Sicherheit & Datenschutz',
    privacy_intro_title: 'Ihre Privatsphäre ist Wichtig',
    privacy_intro_content: 'Spiritual Gems verpflichtet sich, Ihre Privatsphäre zu schützen.',
    privacy_data_title: 'Gesammelte Daten',
    privacy_data_1: 'Kontoinformationen (Benutzername, Pseudonym)',
    privacy_data_2: 'Profilfoto (optional)',
    privacy_data_3: 'Spirituelle Perlen und Kommentare',
    privacy_data_4: 'Private Nachrichten (verschlüsselt)',
    privacy_data_5: 'Bibel-Lesezeichen und Notizen',
    privacy_data_6: 'App-Einstellungen (Sprache, Thema)',
    privacy_data_7: 'Benachrichtigungseinstellungen',
    privacy_advantages_title: 'Nachrichtensicherheit',
    security_auth_title: 'Authentifizierungssicherheit',
    security_username_only: 'Nur Benutzername-Registrierung',
    security_username_only_desc: 'Keine E-Mail erforderlich. Maximaler Datenschutz.',
    security_encryption_rest: 'Verschlüsselung im Ruhezustand (AES-256-GCM)',
    security_encryption_rest_desc: 'Alle Nachrichten werden vor der Speicherung verschlüsselt.',
    security_e2e: 'Ende-zu-Ende-Verschlüsselung (X25519 + AES-256-GCM)',
    security_e2e_desc: 'Nachrichten werden mit dem öffentlichen Schlüssel verschlüsselt.',
    security_rate_limit: 'Ratenbegrenzung',
    security_rate_limit_desc: 'Begrenzt auf 10 Nachrichten pro Minute.',
    security_xss: 'XSS-Schutz',
    security_xss_desc: 'Alle Eingaben werden bereinigt.',
    security_input_validation: 'Eingabevalidierung',
    security_input_validation_desc: 'Inhalte sind längenbegrenzt und bereinigt.',
    security_expiration: 'Nachrichtenablauf',
    security_expiration_desc: 'Nachrichten werden nach 30 Tagen gelöscht.',
    security_https: 'Nur HTTPS',
    security_https_desc: 'Alle Übertragungen sind TLS/SSL-verschlüsselt.',
    security_password: 'Sichere Passwortspeicherung',
    security_password_desc: 'Passwörter werden mit bcrypt gehasht.',
    security_jwt: 'JWT-Authentifizierung',
    security_jwt_desc: 'Token-basierte Authentifizierung mit 72-Stunden-Ablauf.',
    security_notifications_title: 'Push-Benachrichtigungen',
    security_notif_browser: 'Browser-Benachrichtigungen',
    security_notif_browser_desc: 'Aktivieren Sie Push-Benachrichtigungen für neue Nachrichten.',
    security_notif_sound: 'Benachrichtigungstöne & Vibration',
    security_notif_sound_desc: 'Ein sanfter Ton und Vibration auf Mobilgeräten.',
    security_notif_data: 'Benachrichtigungsdaten',
    security_notif_data_desc: 'Benachrichtigungen enthalten keinen Nachrichteninhalt.',
    privacy_limitations_title: 'Sicherheitseinschränkungen',
    limitation_server: 'Serverzugriff',
    limitation_server_desc: 'Administratoren könnten theoretisch Nachrichten entschlüsseln.',
    limitation_metadata: 'Metadaten-Sichtbarkeit',
    limitation_metadata_desc: 'Wir sehen wer wem schreibt, aber nicht den Inhalt.',
    limitation_backup: 'Datenbank-Backups',
    limitation_backup_desc: 'Backups können verschlüsselte Nachrichten enthalten.',
    limitation_device: 'Gerätesicherheit',
    limitation_device_desc: 'Kompromittierte Geräte könnten Nachrichten offenlegen.',
    limitation_social: 'Social Engineering',
    limitation_social_desc: 'Teilen Sie nie Ihr Passwort.',
    privacy_rights_title: 'Ihre Rechte',
    privacy_rights_1: 'Zugriff auf Ihre Daten',
    privacy_rights_2: 'Nachrichten und Inhalte löschen',
    privacy_rights_3: 'Profil aktualisieren',
    privacy_rights_4: 'Private Nachrichten deaktivieren',
    privacy_rights_5: 'Kontolöschung beantragen',
    privacy_rights_6: 'Benachrichtigungsberechtigungen steuern',
    privacy_retention_title: 'Datenspeicherung',
    privacy_retention_content: 'Nachrichten werden nach 30 Tagen gelöscht. Benachrichtigungen bleiben bis zum Lesen.',
    privacy_third_party_title: 'Drittanbieter-Dienste',
    privacy_third_party_1: 'Microsoft Azure Translator (optional)',
    privacy_third_party_2: 'JW.org (Bibelinhalt)',
    privacy_third_party_3: 'PayPal (Spenden)',
    privacy_third_party_note: 'Wir verkaufen Ihre Daten nicht.',
    security_enabled: 'Erweiterte Sicherheit Aktiviert',
    security_badge_desc: 'AES-256 + RSA-2048 + XSS-Schutz',
    privacy_last_updated: 'Zuletzt aktualisiert',
    privacy_contact: 'Fragen? Nutzen Sie "Änderung vorschlagen".',
  },
  it: {
    app_name: 'Gemme Spirituali',
    home: 'Home',
    bible: 'Bibbia',
    search: 'Cerca',
    search_placeholder: 'Cerca gemme, segnalibri, note...',
    search_empty_message: 'Cerca gemme per parola chiave o riferimento del versetto',
    profile: 'Profilo',
    welcome_title: 'Gemme Spirituali e Fatti di Predicazione',
    welcome_subtitle: 'Condividi intuizioni spirituali ed esplora le Sacre Scritture insieme',
    enter_app: 'Entra',
    select_language: 'Seleziona lingua',
    create_gem: 'Condividi una Gemma',
    gem_placeholder: 'Condividi un pensiero spirituale...',
    verse_ref_placeholder: 'Riferimento biblico (opzionale)',
    post: 'Pubblica',
    sort_newest: 'Recenti',
    sort_oldest: 'Vecchie',
    sort_most_liked: 'Più piaciute',
    liked_gems: 'Gemme piaciute',
    cancel: 'Annulla',
    like: 'Mi piace',
    share: 'Condividi',
    report: 'Segnala',
    delete: 'Elimina',
    translate: 'Traduci',
    report_confirm: 'Sei sicuro di voler segnalare questa gemma?',
    delete_confirm: 'Sei sicuro di voler eliminare questa gemma?',
    yes: 'Sì',
    no: 'No',
    no_gems: 'Nessuna gemma ancora. Sii il primo a condividere!',
    loading: 'Caricamento...',
    bible_reader: 'Lettore della Bibbia',
    open_bible: 'Apri la Bibbia',
    audio: 'Audio',
    bookmarks: 'Segnalibri',
    notes: 'Note',
    settings: 'Impostazioni',
    theme: 'Tema',
    font_size: 'Dimensione carattere',
    dark_mode: 'Modalità scura',
    light_mode: 'Modalità chiara',
    donate: 'Dona',
    suggest: 'Suggerisci una modifica',
    about: 'Info',
    admin: 'Amministratore',
    admin_password: 'Password admin',
    reported_gems: 'Gemme segnalate',
    copied: 'Copiato negli appunti',
    gem_posted: 'Gemma pubblicata!',
    gem_deleted: 'Gemma eliminata',
    gem_reported: 'Gemma segnalata. Grazie.',
    share_via: 'Condividi tramite',
    copy_text: 'Copia testo',
    open_translate: 'Apri in Google Translate',
    small: 'Piccolo',
    medium: 'Medio',
    large: 'Grande',
    extra_large: 'Extra grande',
    language: 'Lingua',
    about_nwt: 'Informazioni sulla Traduzione del Nuovo Mondo',
    about_text: 'La Traduzione del Nuovo Mondo delle Sacre Scritture (Revisione 2018) è rinomata per la sua accuratezza, chiarezza e uso del linguaggio moderno.',
    about_title: 'Traduzione del Nuovo Mondo\ndelle Sacre Scritture',
    about_subtitle: 'Revisione 2018',
    about_accuracy_title: 'Accuratezza e fedeltà',
    about_accuracy_text: 'La Traduzione del Nuovo Mondo è stata prodotta da un comitato di studiosi dedicati che hanno dato la priorità alla fedeltà ai testi originali in ebraico, aramaico e greco. A differenza di molte traduzioni che seguono la tradizione piuttosto che l\'accuratezza testuale, la TNM traduce coerentemente il nome personale di Dio, Geova (YHWH), nei quasi 7.000 punti in cui appariva nei manoscritti originali.',
    about_clarity_title: 'Chiarezza e linguaggio moderno',
    about_clarity_text: 'La revisione del 2018 ha aggiornato il linguaggio per renderlo più naturale e facile da capire pur mantenendo l\'accuratezza. Le espressioni arcaiche sono state sostituite con equivalenti moderni, rendendo le Scritture più accessibili ai lettori contemporanei senza sacrificare la profondità e la bellezza del testo originale.',
    about_gods_name_title: 'L\'uso del nome di Dio',
    about_gods_name_text: 'Una delle caratteristiche più distintive della TNM è l\'uso coerente del nome divino Geova. Mentre molte traduzioni hanno rimosso o sostituito il nome personale di Dio con titoli come "SIGNORE", la TNM lo ripristina al suo legittimo posto, permettendo ai lettori di sviluppare un rapporto più personale con l\'Autore della Bibbia.',
    about_languages_title: 'Disponibile in molte lingue',
    about_languages_text: 'La Traduzione del Nuovo Mondo è disponibile in tutto o in parte in oltre 200 lingue, rendendola una delle Bibbie più ampiamente tradotte al mondo. Questa app fornisce accesso alla TNM in 10 lingue, con formati testo e audio.',
    about_learn_more: 'Maggiori informazioni su',
    bible_navigation: 'Navigazione biblica',
    fullscreen: 'Schermo intero',
    exit_fullscreen: 'Esci',
    translating: 'Traduzione in corso...',
    see_original: 'Vedi originale',
    see_translation: 'Vedi traduzione',
    translation_error: 'Errore di traduzione',
    search_bible: 'Cerca nella Bibbia',
    searching: 'Ricerca in tutta la Bibbia...',
    no_results: 'Nessun risultato',
    results_found: 'risultati trovati',
    search_error: 'Errore di ricerca',
    add_bookmark: 'Segnalibro',
    add_note: 'Nota',
    send_message: 'Invia messaggio',
    messages: 'Messaggi',
    new_message: 'Nuovo messaggio',
    type_message: 'Scrivi un messaggio...',
    no_messages: 'Nessun messaggio',
    message_sent: 'Messaggio inviato',
    accept_messages: 'Accetta messaggi privati',
    messages_disabled: 'Questo utente ha disattivato i messaggi privati',
    notifications: 'Notifiche',
    no_notifications: 'Nessuna notifica',
    mark_all_read: 'Segna tutto come letto',
    messages_encrypted: 'I messaggi sono crittografati end-to-end',
    profile_photo: 'Foto profilo',
    change_photo: 'Cambia foto',
    remove_photo: 'Rimuovi foto',
    take_photo: 'Scatta foto',
    choose_from_gallery: 'Scegli dalla galleria',
    adjust_photo: 'Regola foto',
    drag_to_position: 'Usa le frecce per posizionare',
    center: 'Centra',
    guest_mode: 'Modalità ospite',
    sign_in_prompt: 'Accedi per personalizzare la tua esperienza',
    logout: 'Esci',
    save_changes: 'Salva modifiche',
    profile_updated: 'Profilo aggiornato',
    photo_removed: 'Foto rimossa',
    admin_access_granted: 'Accesso amministratore concesso',
    login: 'Accedi',
    register: 'Registrati',
    login_to_post: 'Accedi per pubblicare',
    share_preaching: 'Condividi un rapporto',
    preaching: 'Predicazione',
    new_report: 'Nuovo rapporto',
    no_reports: 'Nessun rapporto',
    report_posted: 'Rapporto pubblicato',
    report_deleted: 'Rapporto eliminato',
    preaching_notes_placeholder: 'Condividi la tua esperienza...',
    date: 'Data',
    all: 'Tutto',
    cat_presentoir: 'Espositore',
    cat_porte_a_porte: 'Porta a porta',
    cat_rue: 'Strada',
    cat_telephone: 'Telefono',
    cat_courrier: 'Lettera',
    cat_informel: 'Informale',
    cookie_title: 'Cookie e privacy',
    cookie_message: 'Utilizziamo cookie per pubblicità e analisi.',
    cookie_accept: 'Accetta',
    cookie_decline: 'Solo non personalizzati',
    ad_loading_title: 'Caricamento della tua esperienza personalizzata...',
    ad_loading_subtitle: 'Preparazione dei contenuti nella tua lingua',
    ad_revenue: 'Entrate pubblicitarie (stima)',
    ad_revenue_history: 'Entrate pubblicitarie mensili',
    scroll_down_audio: 'Scorri verso il basso per vedere il lettore audio',
    loading_bible: 'Caricamento della Bibbia...',
    loading_first_time: 'Il primo caricamento potrebbe richiedere qualche secondo',
    security_ddos: 'Protezione DDoS',
    security_ddos_desc: 'Protezione multilivello: rallentamento a 80 req/min, blocco a 120, ban automatico a 300 req/min.',
    // Bible Audio
    audio_bible: 'Bibbia Audio',
    select_book: 'Seleziona Libro',
    choose_book: 'Scegli un libro...',
    select_chapter: 'Seleziona Capitolo',
    choose_chapter: 'Scegli un capitolo...',
    books_available: 'libri',
    audio_chapters: 'capitoli audio',
    bookmark_label_placeholder: 'Etichetta (es. Genesi 1:1)',
    verse_ref_placeholder: 'Riferimento biblico (opzionale)',
    note_placeholder: 'La tua nota...',
    bible_not_available: 'Bibbia non disponibile',
    bible_not_available_desc: 'La Bibbia non è ancora disponibile in questa lingua su jw.org.',
    // Toast & UI messages
    bookmark_added: 'Segnalibro aggiunto',
    bookmark_deleted: 'Segnalibro eliminato',
    note_saved: 'Nota salvata',
    note_deleted: 'Nota eliminata',
    comment_added: 'Commento aggiunto',
    comment_reported: 'Commento segnalato',
    gem_deleted_admin: 'Perle supprimée par admin',
    messages_enabled: 'Messaggi attivati',
    messages_disabled_toast: 'Messaggi disattivati',
    password_changed: 'Password cambiata',
    password_change_failed: 'Errore du changement de mot de passe',
    account_deleted: 'Account eliminato',
    account_delete_failed: 'Errore de la suppression du compte',
    auth_failed: 'Autenticazione fallita',
    update_failed: 'Errore de la mise à jour',
    image_too_large: 'L\'image doit faire moins de 2 Mo',
    invalid_password: 'Password non valida',
    search_failed: 'Ricerca fallita',
    search_unavailable: 'Recherche indisponible',
    error: 'Errore',
    failed_load_gems: 'Errore du chargement des perles',
    failed_load_audio: 'Errore du chargement audio',
    failed_load_comments: 'Errore du chargement des commentaires',
    failed_load_conversations: 'Errore du chargement des conversations',
    failed_load_messages: 'Errore du chargement des messages',
    failed_load_reported: 'Errore du chargement du contenu signalé',
    failed_load_stats: 'Errore du chargement des statistiques',
    failed_add_bookmark: 'Errore de l\'ajout du signet',
    failed_add_comment: 'Errore de l\'ajout du commentaire',
    failed_delete: 'Errore de la suppression',
    failed_delete_gem: 'Errore de la suppression de la perle',
    failed_delete_bookmark: 'Errore de la suppression du signet',
    failed_delete_note: 'Errore de la suppression de la note',
    failed_save_note: 'Errore de l\'enregistrement de la note',
    failed_update_like: 'Errore de la mise à jour',
    failed_update_photo: 'Errore de la mise à jour de la photo',
    failed_update_settings: 'Errore de la mise à jour des paramètres',
    failed_remove_photo: 'Errore de la suppression de la photo',
    failed_report: 'Errore du signalement',
    failed_report_comment: 'Errore du signalement du commentaire',
    failed_like_comment: 'Errore du j\'aime',
    change_password: 'Cambia password',
    current_password: 'Password attuale',
    new_password: 'Nuova password (min. 6 caratteri)',
    delete_account: 'Elimina account',
    delete_account_warning: 'Questo eliminerà permanentemente il tuo account e tutti i dati.',
    confirm_password: 'Inserisci la password per confermare',
    confirm_delete_account: 'Elimina account permanentemente',
    search_users: 'Cerca utenti...',
    start_conversation_hint: 'Clicca su un nome per iniziare una conversazione',
    // Privacy & Security
    privacy_policy: 'Privacy e Sicurezza',
    encrypted: 'Crittografato',
    privacy_subtitle: 'Sicurezza e Protezione Dati',
    privacy_intro_title: 'La Tua Privacy Conta',
    privacy_intro_content: 'Spiritual Gems si impegna a proteggere la tua privacy e i tuoi dati personali.',
    privacy_data_title: 'Dati Raccolti',
    privacy_data_1: 'Informazioni account (nome utente, pseudonimo)',
    privacy_data_2: 'Foto profilo (opzionale)',
    privacy_data_3: 'Perle spirituali e commenti',
    privacy_data_4: 'Messaggi privati (crittografati)',
    privacy_data_5: 'Segnalibri e note bibliche',
    privacy_data_6: 'Preferenze app (lingua, tema)',
    privacy_data_7: 'Preferenze notifiche',
    privacy_advantages_title: 'Sicurezza Messaggi',
    security_auth_title: 'Sicurezza Autenticazione',
    security_username_only: 'Registrazione solo nome utente',
    security_username_only_desc: 'Nessuna email richiesta. Privacy massimizzata.',
    security_encryption_rest: 'Crittografia a Riposo (AES-256-GCM)',
    security_encryption_rest_desc: 'Tutti i messaggi sono crittografati prima dell\'archiviazione.',
    security_e2e: 'Crittografia End-to-End (X25519 + AES-256-GCM)',
    security_e2e_desc: 'I messaggi sono crittografati con la chiave pubblica del destinatario.',
    security_rate_limit: 'Limitazione Velocità',
    security_rate_limit_desc: 'Limitato a 10 messaggi al minuto.',
    security_xss: 'Protezione XSS',
    security_xss_desc: 'Tutti gli input sono sanificati.',
    security_input_validation: 'Validazione Input',
    security_input_validation_desc: 'Contenuti limitati in lunghezza e sanificati.',
    security_expiration: 'Scadenza Messaggi',
    security_expiration_desc: 'I messaggi si eliminano dopo 30 giorni.',
    security_https: 'Solo HTTPS',
    security_https_desc: 'Tutte le trasmissioni sono crittografate TLS/SSL.',
    security_password: 'Archiviazione Sicura Password',
    security_password_desc: 'Le password sono hashate con bcrypt.',
    security_jwt: 'Autenticazione JWT',
    security_jwt_desc: 'Autenticazione basata su token con scadenza 72 ore.',
    security_notifications_title: 'Notifiche Push',
    security_notif_browser: 'Notifiche Browser',
    security_notif_browser_desc: 'Attiva le notifiche push per nuovi messaggi.',
    security_notif_sound: 'Suoni e Vibrazione',
    security_notif_sound_desc: 'Un suono delicato e vibrazione su dispositivi mobili.',
    security_notif_data: 'Dati Notifica',
    security_notif_data_desc: 'Le notifiche non contengono contenuto dei messaggi.',
    privacy_limitations_title: 'Limitazioni di Sicurezza',
    limitation_server: 'Accesso Server',
    limitation_server_desc: 'Gli amministratori potrebbero teoricamente decifrare i messaggi.',
    limitation_metadata: 'Visibilità Metadati',
    limitation_metadata_desc: 'Vediamo chi invia a chi, ma non il contenuto.',
    limitation_backup: 'Backup Database',
    limitation_backup_desc: 'I backup possono contenere messaggi crittografati.',
    limitation_device: 'Sicurezza Dispositivo',
    limitation_device_desc: 'Un dispositivo compromesso potrebbe rivelare i messaggi.',
    limitation_social: 'Ingegneria Sociale',
    limitation_social_desc: 'Non condividere mai la tua password.',
    privacy_rights_title: 'I Tuoi Diritti',
    privacy_rights_1: 'Accedere ai tuoi dati',
    privacy_rights_2: 'Eliminare messaggi e contenuti',
    privacy_rights_3: 'Aggiornare il profilo',
    privacy_rights_4: 'Disattivare messaggi privati',
    privacy_rights_5: 'Richiedere eliminazione account',
    privacy_rights_6: 'Controllare permessi notifiche',
    privacy_retention_title: 'Conservazione Dati',
    privacy_retention_content: 'I messaggi si eliminano dopo 30 giorni. Le notifiche restano fino alla lettura.',
    privacy_third_party_title: 'Servizi di Terze Parti',
    privacy_third_party_1: 'Microsoft Azure Translator (opzionale)',
    privacy_third_party_2: 'JW.org (contenuto biblico)',
    privacy_third_party_3: 'PayPal (donazioni)',
    privacy_third_party_note: 'Non vendiamo i tuoi dati.',
    security_enabled: 'Sicurezza Avanzata Attivata',
    security_badge_desc: 'AES-256 + RSA-2048 + Protezione XSS',
    privacy_last_updated: 'Ultimo aggiornamento',
    privacy_contact: 'Domande? Usa "Suggerisci una modifica".',
  },
  pt: {
    app_name: 'Pérolas Espirituais',
    home: 'Início',
    bible: 'Bíblia',
    search: 'Buscar',
    search_placeholder: 'Pesquisar pérolas, favoritos, notas...',
    search_empty_message: 'Pesquisar pérolas por palavra-chave ou referência de versículo',
    profile: 'Perfil',
    welcome_title: 'Pérolas Espirituais e Fatos de Pregação',
    welcome_subtitle: 'Compartilhe ideias espirituais e explore as Escrituras Sagradas juntos',
    enter_app: 'Entrar',
    select_language: 'Selecionar idioma',
    create_gem: 'Compartilhar uma Pérola',
    gem_placeholder: 'Compartilhe uma ideia espiritual...',
    verse_ref_placeholder: 'Referência bíblica (opcional)',
    post: 'Publicar',
    sort_newest: 'Recentes',
    sort_oldest: 'Antigas',
    sort_most_liked: 'Mais curtidas',
    liked_gems: 'Pérolas curtidas',
    cancel: 'Cancelar',
    like: 'Curtir',
    share: 'Compartilhar',
    report: 'Denunciar',
    delete: 'Excluir',
    translate: 'Traduzir',
    report_confirm: 'Tem certeza de que deseja denunciar esta pérola?',
    delete_confirm: 'Tem certeza de que deseja excluir esta pérola?',
    yes: 'Sim',
    no: 'Não',
    no_gems: 'Nenhuma pérola ainda. Seja o primeiro a compartilhar!',
    loading: 'Carregando...',
    bible_reader: 'Leitor da Bíblia',
    open_bible: 'Abrir Bíblia',
    audio: 'Áudio',
    bookmarks: 'Marcadores',
    notes: 'Notas',
    settings: 'Configurações',
    theme: 'Tema',
    font_size: 'Tamanho da fonte',
    dark_mode: 'Modo escuro',
    light_mode: 'Modo claro',
    donate: 'Doar',
    suggest: 'Sugerir uma modificação',
    about: 'Sobre',
    admin: 'Administrador',
    admin_password: 'Senha do admin',
    reported_gems: 'Pérolas denunciadas',
    copied: 'Copiado para a área de transferência',
    gem_posted: 'Pérola publicada!',
    gem_deleted: 'Pérola excluída',
    gem_reported: 'Pérola denunciada. Obrigado.',
    share_via: 'Compartilhar via',
    copy_text: 'Copiar texto',
    open_translate: 'Abrir no Google Translate',
    small: 'Pequeno',
    medium: 'Médio',
    large: 'Grande',
    extra_large: 'Extra grande',
    language: 'Idioma',
    about_nwt: 'Sobre a Tradução do Novo Mundo',
    about_text: 'A Tradução do Novo Mundo das Escrituras Sagradas (Revisão de 2018) é reconhecida por sua precisão, clareza e uso de linguagem moderna.',
    about_title: 'Tradução do Novo Mundo\ndas Escrituras Sagradas',
    about_subtitle: 'Revisão de 2018',
    about_accuracy_title: 'Precisão e fidelidade',
    about_accuracy_text: 'A Tradução do Novo Mundo foi produzida por um comitê de estudiosos dedicados que priorizaram a fidelidade aos textos originais em hebraico, aramaico e grego. Ao contrário de muitas traduções que seguem a tradição em vez da precisão textual, a TNM traduz consistentemente o nome pessoal de Deus, Jeová (YHWH), nos quase 7.000 lugares onde ele aparecia nos manuscritos originais.',
    about_clarity_title: 'Clareza e linguagem moderna',
    about_clarity_text: 'A revisão de 2018 atualizou a linguagem para torná-la mais natural e fácil de entender, mantendo a precisão. Expressões arcaicas foram substituídas por equivalentes modernos, tornando as Escrituras mais acessíveis aos leitores contemporâneos sem sacrificar a profundidade e a beleza do texto original.',
    about_gods_name_title: 'O uso do nome de Deus',
    about_gods_name_text: 'Uma das características mais distintivas da TNM é o uso consistente do nome divino Jeová. Enquanto muitas traduções removeram ou substituíram o nome pessoal de Deus por títulos como "SENHOR", a TNM o restaura ao seu lugar legítimo, permitindo que os leitores desenvolvam um relacionamento mais pessoal com o Autor da Bíblia.',
    about_languages_title: 'Disponível em muitos idiomas',
    about_languages_text: 'A Tradução do Novo Mundo está disponível total ou parcialmente em mais de 200 idiomas, tornando-a uma das Bíblias mais amplamente traduzidas do mundo. Este aplicativo fornece acesso à TNM em 10 idiomas, com formatos de texto e áudio.',
    about_learn_more: 'Saiba mais em',
    bible_navigation: 'Navegação da Bíblia',
    fullscreen: 'Tela cheia',
    exit_fullscreen: 'Sair',
    translating: 'Traduzindo...',
    see_original: 'Ver original',
    see_translation: 'Ver tradução',
    translation_error: 'Erro de tradução',
    search_bible: 'Pesquisar na Bíblia',
    searching: 'Pesquisando em toda a Bíblia...',
    no_results: 'Sem resultados',
    results_found: 'resultados encontrados',
    search_error: 'Erro de pesquisa',
    add_bookmark: 'Marcador',
    add_note: 'Nota',
    send_message: 'Enviar mensagem',
    messages: 'Mensagens',
    new_message: 'Nova mensagem',
    type_message: 'Digite uma mensagem...',
    no_messages: 'Nenhuma mensagem',
    message_sent: 'Mensagem enviada',
    accept_messages: 'Aceitar mensagens privadas',
    messages_disabled: 'Este usuário desativou mensagens privadas',
    notifications: 'Notificações',
    no_notifications: 'Sem notificações',
    mark_all_read: 'Marcar tudo como lido',
    messages_encrypted: 'As mensagens são criptografadas de ponta a ponta',
    profile_photo: 'Foto do perfil',
    change_photo: 'Alterar foto',
    remove_photo: 'Remover foto',
    take_photo: 'Tirar foto',
    choose_from_gallery: 'Escolher da galeria',
    adjust_photo: 'Ajustar foto',
    drag_to_position: 'Use as setas para posicionar',
    center: 'Centralizar',
    guest_mode: 'Modo visitante',
    sign_in_prompt: 'Entre para personalizar sua experiência',
    logout: 'Sair',
    save_changes: 'Salvar alterações',
    profile_updated: 'Perfil atualizado',
    photo_removed: 'Foto removida',
    admin_access_granted: 'Acesso de administrador concedido',
    login: 'Entrar',
    register: 'Cadastrar',
    login_to_post: 'Faça login para publicar',
    share_preaching: 'Compartilhar relatório',
    preaching: 'Pregação',
    new_report: 'Novo relatório',
    no_reports: 'Sem relatórios',
    report_posted: 'Relatório publicado',
    report_deleted: 'Relatório excluído',
    preaching_notes_placeholder: 'Compartilhe sua experiência...',
    date: 'Data',
    all: 'Todos',
    cat_presentoir: 'Expositor',
    cat_porte_a_porte: 'Porta a porta',
    cat_rue: 'Rua',
    cat_telephone: 'Telefone',
    cat_courrier: 'Carta',
    cat_informel: 'Informal',
    cookie_title: 'Cookies e privacidade',
    cookie_message: 'Usamos cookies para anúncios e análises.',
    cookie_accept: 'Aceitar',
    cookie_decline: 'Apenas não personalizados',
    ad_loading_title: 'Carregando sua experiência personalizada...',
    ad_loading_subtitle: 'Preparando conteúdo no seu idioma',
    ad_revenue: 'Receita publicitária (est.)',
    ad_revenue_history: 'Receita publicitária mensal',
    scroll_down_audio: 'Role para baixo para ver o player de áudio',
    loading_bible: 'Carregando a Bíblia...',
    loading_first_time: 'O primeiro carregamento pode levar alguns segundos',
    security_ddos: 'Proteção DDoS',
    security_ddos_desc: 'Proteção multicamada: desaceleração a 80 req/min, bloqueio a 120, banimento a 300 req/min.',
    // Bible Audio
    audio_bible: 'Bíblia em Áudio',
    select_book: 'Selecionar Livro',
    choose_book: 'Escolha um livro...',
    select_chapter: 'Selecionar Capítulo',
    choose_chapter: 'Escolha um capítulo...',
    books_available: 'livros',
    audio_chapters: 'capítulos de áudio',
    bookmark_label_placeholder: 'Rótulo (ex. Gênesis 1:1)',
    verse_ref_placeholder: 'Referência bíblica (opcional)',
    note_placeholder: 'Sua nota...',
    bible_not_available: 'Bíblia não disponível',
    bible_not_available_desc: 'A Bíblia ainda não está disponível neste idioma no jw.org.',
    // Toast & UI messages
    bookmark_added: 'Marcador adicionado',
    bookmark_deleted: 'Marcador excluído',
    note_saved: 'Nota salva',
    note_deleted: 'Nota excluída',
    comment_added: 'Comentário adicionado',
    comment_reported: 'Comentário denunciado',
    messages_enabled: 'Mensagens ativadas',
    messages_disabled_toast: 'Mensagens desativadas',
    password_changed: 'Senha alterada',
    account_deleted: 'Conta excluída',
    auth_failed: 'Falha na autenticação',
    invalid_password: 'Senha inválida',
    change_password: 'Alterar senha',
    current_password: 'Senha atual',
    new_password: 'Nova senha (mín. 6 caracteres)',
    delete_account: 'Excluir conta',
    delete_account_warning: 'Isso excluirá permanentemente sua conta e todos os dados.',
    confirm_password: 'Digite a senha para confirmar',
    confirm_delete_account: 'Excluir conta permanentemente',
    search_users: 'Buscar usuários...',
    start_conversation_hint: 'Clique em um nome para iniciar uma conversa',
    error: 'Erro',
    search_failed: 'Falha na busca',
    search_unavailable: 'Busca indisponível',
    image_too_large: 'A imagem deve ter menos de 2MB',
    update_failed: 'Falha na atualização',
    gem_deleted_admin: 'Gema eliminada por admin',
    password_change_failed: 'Erro al cambiar contraseña',
    account_delete_failed: 'Erro al eliminar cuenta',
    failed_load_gems: 'Erro al cargar gemas',
    failed_load_audio: 'Erro al cargar audio',
    failed_load_comments: 'Erro al cargar comentarios',
    failed_load_conversations: 'Erro al cargar conversaciones',
    failed_load_messages: 'Erro al cargar mensajes',
    failed_load_reported: 'Erro al cargar reportados',
    failed_load_stats: 'Erro al cargar estadísticas',
    failed_add_bookmark: 'Erro al agregar marcador',
    failed_add_comment: 'Erro al agregar comentario',
    failed_delete: 'Erro al eliminar',
    failed_delete_gem: 'Erro al eliminar gema',
    failed_delete_bookmark: 'Erro al eliminar marcador',
    failed_delete_note: 'Erro al eliminar nota',
    failed_save_note: 'Erro al guardar nota',
    failed_update_like: 'Erro al actualizar',
    failed_update_photo: 'Erro al actualizar foto',
    failed_update_settings: 'Erro al actualizar ajustes',
    failed_remove_photo: 'Erro al eliminar foto',
    failed_report: 'Erro al reportar',
    failed_report_comment: 'Erro al reportar comentario',
    failed_like_comment: 'Erro al dar me gusta',
    // Privacy & Security
    privacy_policy: 'Privacidade e Segurança',
    encrypted: 'Criptografado',
    privacy_subtitle: 'Segurança e Proteção de Dados',
    privacy_intro_title: 'Sua Privacidade Importa',
    privacy_intro_content: 'Spiritual Gems se compromete a proteger sua privacidade e seus dados pessoais.',
    privacy_data_title: 'Dados Coletados',
    privacy_data_1: 'Informações da conta (nome de usuário, pseudônimo)',
    privacy_data_2: 'Foto do perfil (opcional)',
    privacy_data_3: 'Pérolas espirituais e comentários',
    privacy_data_4: 'Mensagens privadas (criptografadas)',
    privacy_data_5: 'Marcadores e notas bíblicas',
    privacy_data_6: 'Preferências do app (idioma, tema)',
    privacy_data_7: 'Preferências de notificações',
    privacy_advantages_title: 'Segurança de Mensagens',
    security_auth_title: 'Segurança de Autenticação',
    security_username_only: 'Registro apenas com nome de usuário',
    security_username_only_desc: 'Nenhum e-mail necessário. Privacidade máxima.',
    security_encryption_rest: 'Criptografia em Repouso (AES-256-GCM)',
    security_encryption_rest_desc: 'Todas as mensagens são criptografadas antes do armazenamento.',
    security_e2e: 'Criptografia Ponta a Ponta (X25519 + AES-256-GCM)',
    security_e2e_desc: 'Mensagens criptografadas com a chave pública do destinatário.',
    security_rate_limit: 'Limitação de Taxa',
    security_rate_limit_desc: 'Limitado a 10 mensagens por minuto.',
    security_xss: 'Proteção XSS',
    security_xss_desc: 'Todas as entradas são sanitizadas.',
    security_input_validation: 'Validação de Entrada',
    security_input_validation_desc: 'Conteúdo limitado e sanitizado.',
    security_expiration: 'Expiração de Mensagens',
    security_expiration_desc: 'Mensagens são excluídas após 30 dias.',
    security_https: 'Apenas HTTPS',
    security_https_desc: 'Todas as transmissões são criptografadas TLS/SSL.',
    security_password: 'Armazenamento Seguro de Senhas',
    security_password_desc: 'Senhas são hasheadas com bcrypt.',
    security_jwt: 'Autenticação JWT',
    security_jwt_desc: 'Autenticação baseada em tokens com expiração de 72 horas.',
    security_notifications_title: 'Notificações Push',
    security_notif_browser: 'Notificações do Navegador',
    security_notif_browser_desc: 'Ative notificações push para novas mensagens.',
    security_notif_sound: 'Sons e Vibração',
    security_notif_sound_desc: 'Um toque suave e vibração em dispositivos móveis.',
    security_notif_data: 'Dados de Notificação',
    security_notif_data_desc: 'Notificações não contêm conteúdo de mensagens.',
    privacy_limitations_title: 'Limitações de Segurança',
    limitation_server: 'Acesso ao Servidor',
    limitation_server_desc: 'Administradores poderiam teoricamente decifrar mensagens.',
    limitation_metadata: 'Visibilidade de Metadados',
    limitation_metadata_desc: 'Vemos quem envia para quem, mas não o conteúdo.',
    limitation_backup: 'Backups',
    limitation_backup_desc: 'Backups podem conter mensagens criptografadas.',
    limitation_device: 'Segurança do Dispositivo',
    limitation_device_desc: 'Dispositivo comprometido pode revelar mensagens.',
    limitation_social: 'Engenharia Social',
    limitation_social_desc: 'Nunca compartilhe sua senha.',
    privacy_rights_title: 'Seus Direitos',
    privacy_rights_1: 'Acessar seus dados',
    privacy_rights_2: 'Excluir mensagens e conteúdo',
    privacy_rights_3: 'Atualizar perfil',
    privacy_rights_4: 'Desativar mensagens privadas',
    privacy_rights_5: 'Solicitar exclusão de conta',
    privacy_rights_6: 'Controlar permissões de notificações',
    privacy_retention_title: 'Retenção de Dados',
    privacy_retention_content: 'Mensagens são excluídas após 30 dias. Notificações ficam até serem lidas.',
    privacy_third_party_title: 'Serviços de Terceiros',
    privacy_third_party_1: 'Microsoft Azure Translator (opcional)',
    privacy_third_party_2: 'JW.org (conteúdo bíblico)',
    privacy_third_party_3: 'PayPal (doações)',
    privacy_third_party_note: 'Não vendemos seus dados.',
    security_enabled: 'Segurança Avançada Ativada',
    security_badge_desc: 'AES-256 + RSA-2048 + Proteção XSS',
    privacy_last_updated: 'Última atualização',
    privacy_contact: 'Dúvidas? Use "Sugerir uma modificação".',
  },
  hi: {
    app_name: 'आध्यात्मिक रत्न',
    home: 'होम',
    bible: 'बाइबल',
    search: 'खोजें',
    search_placeholder: 'रत्न, बुकमार्क, नोट्स खोजें...',
    search_empty_message: 'कीवर्ड या पद संदर्भ द्वारा रत्न खोजें',
    profile: 'प्रोफ़ाइल',
    welcome_title: 'आध्यात्मिक रत्न और प्रचार के तथ्य',
    welcome_subtitle: 'आध्यात्मिक अंतर्दृष्टि साझा करें और पवित्र शास्त्रों का अन्वेषण करें',
    enter_app: 'प्रवेश करें',
    select_language: 'भाषा चुनें',
    create_gem: 'एक रत्न साझा करें',
    gem_placeholder: 'एक आध्यात्मिक अंतर्दृष्टि साझा करें...',
    verse_ref_placeholder: 'पद संदर्भ (वैकल्पिक)',
    post: 'पोस्ट करें',
    sort_newest: 'नवीनतम',
    sort_oldest: 'पुरानाइयों',
    sort_most_liked: 'सबसे पसंदीदा',
    liked_gems: 'पसंदीदा रत्न',
    cancel: 'रद्द करें',
    like: 'पसंद',
    share: 'साझा करें',
    report: 'रिपोर्ट',
    delete: 'हटाएं',
    translate: 'अनुवाद',
    report_confirm: 'क्या आप इस रत्न की रिपोर्ट करना चाहते हैं?',
    delete_confirm: 'क्या आप इस रत्न को हटाना चाहते हैं?',
    yes: 'हां',
    no: 'नहीं',
    no_gems: 'अभी कोई रत्न नहीं। पहले साझा करने वाले बनें!',
    loading: 'लोड हो रहा है...',
    bible_reader: 'बाइबल पाठक',
    open_bible: 'बाइबल खोलें',
    audio: 'ऑडियो',
    bookmarks: 'बुकमार्क',
    notes: 'नोट्स',
    settings: 'सेटिंग्स',
    theme: 'थीम',
    font_size: 'फ़ॉन्ट आकार',
    dark_mode: 'डार्क मोड',
    light_mode: 'लाइट मोड',
    donate: 'दान करें',
    suggest: 'सुझाव दें',
    about: 'बारे में',
    admin: 'व्यवस्थापक',
    admin_password: 'एडमिन पासवर्ड',
    reported_gems: 'रिपोर्ट किए गए रत्न',
    copied: 'क्लिपबोर्ड पर कॉपी किया गया',
    gem_posted: 'रत्न प्रकाशित!',
    gem_deleted: 'रत्न हटाया गया',
    gem_reported: 'रत्न की रिपोर्ट की गई। धन्यवाद।',
    share_via: 'के माध्यम से साझा करें',
    copy_text: 'टेक्स्ट कॉपी करें',
    open_translate: 'Google Translate में खोलें',
    small: 'छोटा',
    medium: 'मध्यम',
    large: 'बड़ा',
    extra_large: 'बहुत बड़ा',
    language: 'भाषा',
    about_nwt: 'नई दुनिया अनुवाद के बारे में',
    about_text: 'पवित्र शास्त्र का नई दुनिया अनुवाद (2018 संशोधन) अपनी सटीकता, स्पष्टता और आधुनिक भाषा के उपयोग के लिए प्रसिद्ध है।',
    about_title: 'पवित्र शास्त्र का\nनई दुनिया अनुवाद',
    about_subtitle: '2018 संशोधन',
    about_accuracy_title: 'सटीकता और निष्ठा',
    about_accuracy_text: 'नई दुनिया अनुवाद समर्पित विद्वानों की एक समिति द्वारा तैयार किया गया था जिन्होंने मूल इब्रानी, अरामी और यूनानी ग्रंथों के प्रति निष्ठा को प्राथमिकता दी। कई अनुवादों के विपरीत जो पाठ्य सटीकता पर परंपरा का अनुसरण करते हैं, NWT लगातार परमेश्वर के व्यक्तिगत नाम, यहोवा (YHWH) को लगभग 7,000 स्थानों पर प्रस्तुत करता है जहाँ यह मूल पांडुलिपियों में दिखाई दिया था।',
    about_clarity_title: 'स्पष्टता और आधुनिक भाषा',
    about_clarity_text: '2018 के संशोधन ने भाषा को अधिक स्वाभाविक और समझने में आसान बनाने के लिए अद्यतन किया, जबकि सटीकता बनाए रखी। पुरानी अभिव्यक्तियों को आधुनिक समकक्षों से बदल दिया गया, जिससे शास्त्र मूल पाठ की गहराई और सुंदरता का त्याग किए बिना समकालीन पाठकों के लिए अधिक सुलभ हो गया।',
    about_gods_name_title: 'परमेश्वर के नाम का उपयोग',
    about_gods_name_text: 'NWT की सबसे विशिष्ट विशेषताओं में से एक दिव्य नाम यहोवा का सुसंगत उपयोग है। जबकि कई अनुवादों ने परमेश्वर के व्यक्तिगत नाम को हटा दिया है या "प्रभु" जैसे शीर्षकों से बदल दिया है, NWT इसे उचित स्थान पर बहाल करता है, जिससे पाठक बाइबल के लेखक के साथ अधिक व्यक्तिगत संबंध विकसित कर सकें।',
    about_languages_title: 'कई भाषाओं में उपलब्ध',
    about_languages_text: 'नई दुनिया अनुवाद 200 से अधिक भाषाओं में पूर्ण या आंशिक रूप से उपलब्ध है, जो इसे दुनिया की सबसे व्यापक रूप से अनुवादित बाइबलों में से एक बनाता है। यह ऐप NWT तक 10 भाषाओं में पहुँच प्रदान करता है, पाठ और ऑडियो दोनों प्रारूपों के साथ।',
    about_learn_more: 'अधिक जानें',
    bible_navigation: 'बाइबल नेविगेशन',
    fullscreen: 'पूर्ण स्क्रीन',
    exit_fullscreen: 'बाहर निकलें',
    translating: 'अनुवाद हो रहा है...',
    see_original: 'मूल देखें',
    see_translation: 'अनुवाद देखें',
    translation_error: 'अनुवाद त्रुटि',
    search_bible: 'बाइबल खोजें',
    searching: 'पूरी बाइबल में खोज रहा है...',
    no_results: 'कोई परिणाम नहीं',
    results_found: 'परिणाम मिले',
    search_error: 'खोज त्रुटि',
    add_bookmark: 'बुकमार्क',
    add_note: 'नोट',
    send_message: 'संदेश भेजें',
    messages: 'संदेश',
    new_message: 'नया संदेश',
    type_message: 'संदेश लिखें...',
    no_messages: 'कोई संदेश नहीं',
    message_sent: 'संदेश भेजा गया',
    accept_messages: 'निजी संदेश स्वीकार करें',
    messages_disabled: 'इस उपयोगकर्ता ने निजी संदेश अक्षम कर दिए हैं',
    notifications: 'सूचनाएं',
    no_notifications: 'कोई सूचना नहीं',
    mark_all_read: 'सभी पढ़ा हुआ चिह्नित करें',
    messages_encrypted: 'संदेश एंड-टू-एंड एन्क्रिप्टेड हैं',
    profile_photo: 'प्रोफ़ाइल फ़ोटो',
    change_photo: 'फ़ोटो बदलें',
    remove_photo: 'फ़ोटो हटाएं',
    take_photo: 'फ़ोटो लें',
    choose_from_gallery: 'गैलरी से चुनें',
    adjust_photo: 'फ़ोटो समायोजित करें',
    drag_to_position: 'स्थिति के लिए तीर का उपयोग करें',
    center: 'केंद्र',
    guest_mode: 'अतिथि मोड',
    sign_in_prompt: 'अपने अनुभव को अनुकूलित करने के लिए साइन इन करें',
    logout: 'लॉग आउट',
    save_changes: 'परिवर्तन सहेजें',
    profile_updated: 'प्रोफ़ाइल अपडेट किया गया',
    photo_removed: 'फ़ोटो हटाई गई',
    admin_access_granted: 'व्यवस्थापक पहुंच प्रदान की गई',
    login: 'लॉग इन',
    register: 'रजिस्टर',
    login_to_post: 'पोस्ट करने के लिए लॉग इन करें',
    share_preaching: 'रिपोर्ट साझा करें',
    preaching: 'प्रचार',
    new_report: 'नई रिपोर्ट',
    no_reports: 'कोई रिपोर्ट नहीं',
    report_posted: 'रिपोर्ट प्रकाशित',
    report_deleted: 'रिपोर्ट हटाई गई',
    preaching_notes_placeholder: 'अपना अनुभव साझा करें...',
    date: 'तारीख',
    all: 'सभी',
    cat_presentoir: 'प्रदर्शनी',
    cat_porte_a_porte: 'घर-घर',
    cat_rue: 'सड़क',
    cat_telephone: 'फ़ोन',
    cat_courrier: 'पत्र',
    cat_informel: 'अनौपचारिक',
    cookie_title: 'कुकीज़ और गोपनीयता',
    cookie_message: 'हम विज्ञापनों और विश्लेषण के लिए कुकीज़ का उपयोग करते हैं।',
    cookie_accept: 'स्वीकार करें',
    cookie_decline: 'केवल गैर-व्यक्तिगत',
    ad_loading_title: 'आपका अनुभव लोड हो रहा है...',
    ad_loading_subtitle: 'आपकी भाषा में सामग्री तैयार की जा रही है',
    ad_revenue: 'विज्ञापन आय (अनुमानित)',
    ad_revenue_history: 'मासिक विज्ञापन आय',
    scroll_down_audio: 'ऑडियो प्लेयर देखने के लिए नीचे स्क्रॉल करें',
    loading_bible: 'बाइबल लोड हो रही है...',
    loading_first_time: 'पहली बार लोड होने में कुछ सेकंड लग सकते हैं',
    security_ddos: 'DDoS सुरक्षा',
    security_ddos_desc: 'बहु-स्तरीय सुरक्षा: 80 req/min पर धीमा, 120 पर ब्लॉक, 300 पर ऑटो-बैन।',
    // Bible Audio
    audio_bible: 'ऑडियो बाइबल',
    select_book: 'पुस्तक चुनें',
    choose_book: 'एक पुस्तक चुनें...',
    select_chapter: 'अध्याय चुनें',
    choose_chapter: 'एक अध्याय चुनें...',
    books_available: 'पुस्तकें',
    audio_chapters: 'ऑडियो अध्याय',
    bookmark_label_placeholder: 'लेबल (उदा. उत्पत्ति 1:1)',
    verse_ref_placeholder: 'बाइबल संदर्भ (वैकल्पिक)',
    note_placeholder: 'आपकी टिप्पणी...',
    bible_not_available: 'बाइबल उपलब्ध नहीं',
    bible_not_available_desc: 'यह बाइबल अभी इस भाषा में jw.org पर उपलब्ध नहीं है।',
    // Toast & UI messages
    bookmark_added: 'बुकमार्क जोड़ा गया',
    bookmark_deleted: 'बुकमार्क हटाया',
    note_saved: 'नोट सहेजा गया',
    note_deleted: 'नोट हटाया गया',
    comment_added: 'टिप्पणी जोड़ी गई',
    comment_reported: 'टिप्पणी रिपोर्ट की गई',
    messages_enabled: 'संदेश सक्रिय',
    messages_disabled_toast: 'संदेश अक्षम',
    password_changed: 'पासवर्ड बदला गया',
    account_deleted: 'खाता हटाया गया',
    change_password: 'पासवर्ड बदलें',
    current_password: 'वर्तमान पासवर्ड',
    new_password: 'नया पासवर्ड (न्यूनतम 6 अक्षर)',
    delete_account: 'खाता हटाएं',
    delete_account_warning: 'यह आपके खाते और सभी डेटा को स्थायी रूप से हटा देगा।',
    confirm_password: 'पुष्टि के लिए पासवर्ड दर्ज करें',
    confirm_delete_account: 'खाता स्थायी रूप से हटाएं',
    search_users: 'उपयोगकर्ता खोजें...',
    start_conversation_hint: 'बातचीत शुरू करने के लिए नाम पर क्लिक करें',
    error: 'त्रुटि',
    auth_failed: 'प्रमाणीकरण विफल',
    invalid_password: 'अमान्य पासवर्ड',
    search_failed: 'खोज विफल',
    image_too_large: 'छवि 2MB से कम होनी चाहिए',
    gem_deleted_admin: 'विफल',
    password_change_failed: 'विफल',
    account_delete_failed: 'विफल',
    update_failed: 'विफल',
    search_unavailable: 'विफल',
    failed_load_gems: 'विफल',
    failed_load_audio: 'विफल',
    failed_load_comments: 'विफल',
    failed_load_conversations: 'विफल',
    failed_load_messages: 'विफल',
    failed_load_reported: 'विफल',
    failed_load_stats: 'विफल',
    failed_add_bookmark: 'विफल',
    failed_add_comment: 'विफल',
    failed_delete: 'विफल',
    failed_delete_gem: 'विफल',
    failed_delete_bookmark: 'विफल',
    failed_delete_note: 'विफल',
    failed_save_note: 'विफल',
    failed_update_like: 'विफल',
    failed_update_photo: 'विफल',
    failed_update_settings: 'विफल',
    failed_remove_photo: 'विफल',
    failed_report: 'विफल',
    failed_report_comment: 'विफल',
    failed_like_comment: 'विफल',
    // Privacy & Security
    privacy_policy: 'गोपनीयता और सुरक्षा',
    encrypted: 'एन्क्रिप्टेड',
    privacy_subtitle: 'सुरक्षा और डेटा संरक्षण',
    privacy_intro_title: 'आपकी गोपनीयता महत्वपूर्ण है',
    privacy_intro_content: 'Spiritual Gems आपकी गोपनीयता की रक्षा के लिए प्रतिबद्ध है।',
    privacy_data_title: 'एकत्रित डेटा',
    privacy_data_1: 'खाता जानकारी (उपयोगकर्ता नाम, उपनाम)',
    privacy_data_2: 'प्रोफ़ाइल फ़ोटो (वैकल्पिक)',
    privacy_data_3: 'आध्यात्मिक रत्न और टिप्पणियाँ',
    privacy_data_4: 'निजी संदेश (एन्क्रिप्टेड)',
    privacy_data_5: 'बाइबल बुकमार्क और नोट्स',
    privacy_data_6: 'ऐप प्राथमिकताएं (भाषा, थीम)',
    privacy_data_7: 'सूचना प्राथमिकताएं',
    privacy_advantages_title: 'संदेश सुरक्षा',
    security_auth_title: 'प्रमाणीकरण सुरक्षा',
    security_username_only: 'केवल उपयोगकर्ता नाम पंजीकरण',
    security_username_only_desc: 'कोई ईमेल आवश्यक नहीं। अधिकतम गोपनीयता।',
    security_encryption_rest: 'रेस्ट एन्क्रिप्शन (AES-256-GCM)',
    security_encryption_rest_desc: 'सभी संदेश भंडारण से पहले एन्क्रिप्ट किए जाते हैं।',
    security_e2e: 'एंड-टू-एंड एन्क्रिप्शन (X25519 + AES-256-GCM)',
    security_e2e_desc: 'संदेश प्राप्तकर्ता की सार्वजनिक कुंजी से एन्क्रिप्ट होते हैं।',
    security_rate_limit: 'दर सीमा',
    security_rate_limit_desc: 'प्रति मिनट 10 संदेशों तक सीमित।',
    security_xss: 'XSS सुरक्षा',
    security_xss_desc: 'सभी इनपुट साफ किए जाते हैं।',
    security_input_validation: 'इनपुट सत्यापन',
    security_input_validation_desc: 'सामग्री लंबाई-सीमित और साफ है।',
    security_expiration: 'संदेश समाप्ति',
    security_expiration_desc: 'संदेश 30 दिनों के बाद हटा दिए जाते हैं।',
    security_https: 'केवल HTTPS',
    security_https_desc: 'सभी प्रसारण TLS/SSL एन्क्रिप्टेड।',
    security_password: 'सुरक्षित पासवर्ड भंडारण',
    security_password_desc: 'पासवर्ड bcrypt से हैश होते हैं।',
    security_jwt: 'JWT प्रमाणीकरण',
    security_jwt_desc: '72 घंटे की समाप्ति के साथ टोकन प्रमाणीकरण।',
    security_notifications_title: 'पुश सूचनाएं',
    security_notif_browser: 'ब्राउज़र सूचनाएं',
    security_notif_browser_desc: 'नए संदेशों के लिए पुश सूचनाएं सक्रिय करें।',
    security_notif_sound: 'ध्वनि और कंपन',
    security_notif_sound_desc: 'मोबाइल पर एक हल्की ध्वनि और कंपन।',
    security_notif_data: 'सूचना डेटा',
    security_notif_data_desc: 'सूचनाओं में संदेश सामग्री नहीं होती।',
    privacy_limitations_title: 'सुरक्षा सीमाएं',
    limitation_server: 'सर्वर एक्सेस',
    limitation_server_desc: 'व्यवस्थापक सैद्धांतिक रूप से संदेश डिक्रिप्ट कर सकते हैं।',
    limitation_metadata: 'मेटाडेटा दृश्यता',
    limitation_metadata_desc: 'हम देखते हैं कौन किसे भेजता है, लेकिन सामग्री नहीं।',
    limitation_backup: 'बैकअप',
    limitation_backup_desc: 'बैकअप में एन्क्रिप्टेड संदेश हो सकते हैं।',
    limitation_device: 'डिवाइस सुरक्षा',
    limitation_device_desc: 'समझौता किया गया डिवाइस संदेश प्रकट कर सकता है।',
    limitation_social: 'सोशल इंजीनियरिंग',
    limitation_social_desc: 'अपना पासवर्ड कभी साझा न करें।',
    privacy_rights_title: 'आपके अधिकार',
    privacy_rights_1: 'अपने डेटा तक पहुंचें',
    privacy_rights_2: 'संदेश और सामग्री हटाएं',
    privacy_rights_3: 'प्रोफ़ाइल अपडेट करें',
    privacy_rights_4: 'निजी संदेश अक्षम करें',
    privacy_rights_5: 'खाता हटाने का अनुरोध करें',
    privacy_rights_6: 'सूचना अनुमतियां नियंत्रित करें',
    privacy_retention_title: 'डेटा प्रतिधारण',
    privacy_retention_content: 'संदेश 30 दिनों के बाद हटाए जाते हैं। सूचनाएं पढ़ने तक रहती हैं।',
    privacy_third_party_title: 'तृतीय-पक्ष सेवाएं',
    privacy_third_party_1: 'Microsoft Azure Translator (वैकल्पिक)',
    privacy_third_party_2: 'JW.org (बाइबल सामग्री)',
    privacy_third_party_3: 'PayPal (दान)',
    privacy_third_party_note: 'हम आपका डेटा नहीं बेचते।',
    security_enabled: 'उन्नत सुरक्षा सक्रिय',
    security_badge_desc: 'AES-256 + RSA-2048 + XSS सुरक्षा',
    privacy_last_updated: 'अंतिम अपडेट',
    privacy_contact: 'प्रश्न? "सुझाव" बटन का उपयोग करें।',
  },
  zh: {
    app_name: '灵性宝石',
    home: '首页',
    bible: '圣经',
    search: '搜索',
    search_placeholder: '搜索宝石、书签、笔记...',
    search_empty_message: '按关键字或经文引用搜索宝石',
    profile: '个人资料',
    welcome_title: '灵性宝石与传道事迹',
    welcome_subtitle: '分享灵性见解，一起探索圣经',
    enter_app: '进入应用',
    select_language: '选择语言',
    create_gem: '分享一颗宝石',
    gem_placeholder: '分享一个灵性见解...',
    verse_ref_placeholder: '经文参考（可选）',
    post: '发布',
    sort_newest: '最新',
    sort_oldest: '最旧',
    sort_most_liked: '最受欢迎',
    liked_gems: '喜欢的宝石',
    cancel: '取消',
    like: '喜欢',
    share: '分享',
    report: '举报',
    delete: '删除',
    translate: '翻译',
    no_gems: '还没有宝石。成为第一个分享的人！',
    loading: '加载中...',
    settings: '设置',
    donate: '捐赠',
    about: '关于',
    language: '语言',
    about_nwt: '关于《新世界译本》',
    about_text: '《圣经新世界译本》（2018年修订版）以其准确性、清晰度和现代语言的使用而闻名。',
    about_title: '圣经新世界译本',
    about_subtitle: '2018年修订版',
    about_accuracy_title: '准确性与忠实性',
    about_accuracy_text: '《新世界译本》由一群敬业的学者委员会编制，他们优先考虑对希伯来语、亚拉姆语和希腊语原文的忠实。与许多遵循传统而非文本准确性的译本不同，NWT始终如一地在原始手稿中出现的近7000处使用上帝的个人名字耶和华（YHWH）。',
    about_clarity_title: '清晰度与现代语言',
    about_clarity_text: '2018年修订版更新了语言，使其更加自然和易于理解，同时保持准确性。古老的表达方式被现代等效词替换，使经文在不牺牲原文深度和美感的情况下更加适合当代读者。',
    about_gods_name_title: '上帝名字的使用',
    about_gods_name_text: 'NWT最显著的特征之一是始终如一地使用神圣的名字耶和华。虽然许多译本已经删除或用"主"等称号替换了上帝的个人名字，但NWT将其恢复到应有的位置，使读者能够与圣经的作者建立更加亲密的关系。',
    about_languages_title: '多种语言版本',
    about_languages_text: '《新世界译本》已全部或部分翻译成200多种语言，是世界上翻译最广泛的圣经之一。此应用程序提供10种语言的NWT访问，包括文本和音频格式。',
    about_learn_more: '了解更多',
    bible_navigation: '圣经导航',
    fullscreen: '全屏',
    exit_fullscreen: '退出',
    translating: '翻译中...',
    see_original: '查看原文',
    see_translation: '查看翻译',
    translation_error: '翻译错误',
    search_bible: '搜索圣经',
    searching: '正在搜索整本圣经...',
    no_results: '未找到结果',
    results_found: '个结果',
    search_error: '搜索错误',
    add_bookmark: '书签',
    add_note: '笔记',
    send_message: '发送消息',
    messages: '消息',
    new_message: '新消息',
    type_message: '输入消息...',
    no_messages: '没有消息',
    message_sent: '消息已发送',
    accept_messages: '接受私信',
    messages_disabled: '该用户已关闭私信',
    notifications: '通知',
    no_notifications: '暂无通知',
    mark_all_read: '全部标为已读',
    messages_encrypted: '消息已端到端加密',
    profile_photo: '头像',
    change_photo: '更换照片',
    remove_photo: '删除照片',
    take_photo: '拍照',
    choose_from_gallery: '从相册选择',
    adjust_photo: '调整照片',
    drag_to_position: '使用箭头定位',
    center: '居中',
    guest_mode: '访客模式',
    sign_in_prompt: '登录以个性化您的体验',
    logout: '退出登录',
    save_changes: '保存更改',
    profile_updated: '个人资料已更新',
    photo_removed: '照片已删除',
    admin_access_granted: '管理员访问已授权',
    login: '登录',
    register: '注册',
    login_to_post: '请登录后发布',
    share_preaching: '分享报告',
    preaching: '传道',
    new_report: '新报告',
    no_reports: '暂无报告',
    report_posted: '报告已发布',
    report_deleted: '报告已删除',
    preaching_notes_placeholder: '分享你的经历...',
    date: '日期',
    all: '全部',
    cat_presentoir: '展示台',
    cat_porte_a_porte: '逐户',
    cat_rue: '街头',
    cat_telephone: '电话',
    cat_courrier: '信件',
    cat_informel: '非正式',
    cookie_title: 'Cookie与隐私',
    cookie_message: '我们使用Cookie进行广告和分析。',
    cookie_accept: '接受',
    cookie_decline: '仅非个性化',
    ad_loading_title: '正在加载您的个性化体验...',
    ad_loading_subtitle: '正在以您的语言准备内容',
    ad_revenue: '广告收入（估计）',
    ad_revenue_history: '月度广告收入',
    scroll_down_audio: '向下滚动查看音频播放器',
    loading_bible: '正在加载圣经...',
    loading_first_time: '首次加载可能需要几秒钟',
    // Bible Audio
    audio_bible: '有声圣经',
    select_book: '选择书卷',
    choose_book: '选择一卷书...',
    select_chapter: '选择章节',
    choose_chapter: '选择一个章节...',
    books_available: '卷书',
    audio_chapters: '音频章节',
    bookmark_label_placeholder: '标签（例如 创世记 1:1）',
    verse_ref_placeholder: '经文参考（可选）',
    note_placeholder: '你的笔记...',
    bible_not_available: '圣经不可用',
    bible_not_available_desc: '此语言的圣经在jw.org上尚不可用。',
    // Toast & UI messages
    bookmark_added: '书签已添加',
    bookmark_deleted: '书签已删除',
    note_saved: '笔记已保存',
    note_deleted: '笔记已删除',
    comment_added: '评论已添加',
    messages_enabled: '消息已启用',
    messages_disabled_toast: '消息已禁用',
    password_changed: '密码已更改',
    change_password: '更改密码',
    current_password: '当前密码',
    new_password: '新密码（至少6个字符）',
    delete_account: '删除账户',
    delete_account_warning: '这将永久删除您的账户和所有数据。',
    confirm_password: '输入密码确认',
    confirm_delete_account: '永久删除账户',
    search_users: '搜索用户...',
    error: '失败',
    auth_failed: '认证失败',
    invalid_password: '密码无效',
    search_failed: '搜索失败',
    comment_reported: '失败',
    gem_deleted_admin: '失败',
    password_change_failed: '失败',
    account_deleted: '失败',
    account_delete_failed: '失败',
    update_failed: '失败',
    image_too_large: '失败',
    search_unavailable: '失败',
    failed_load_gems: '失败',
    failed_load_audio: '失败',
    failed_load_comments: '失败',
    failed_load_conversations: '失败',
    failed_load_messages: '失败',
    failed_load_reported: '失败',
    failed_load_stats: '失败',
    failed_add_bookmark: '失败',
    failed_add_comment: '失败',
    failed_delete: '失败',
    failed_delete_gem: '失败',
    failed_delete_bookmark: '失败',
    failed_delete_note: '失败',
    failed_save_note: '失败',
    failed_update_like: '失败',
    failed_update_photo: '失败',
    failed_update_settings: '失败',
    failed_remove_photo: '失败',
    failed_report: '失败',
    failed_report_comment: '失败',
    failed_like_comment: '失败',
    start_conversation_hint: '失败',
    // Privacy & Security
    privacy_policy: '隐私与安全',
    encrypted: '已加密',
    privacy_subtitle: '安全与数据保护',
    privacy_intro_title: '您的隐私很重要',
    privacy_intro_content: 'Spiritual Gems致力于保护您的隐私和个人数据安全。',
    privacy_data_title: '收集的数据',
    privacy_data_1: '账户信息（用户名、昵称）',
    privacy_data_2: '头像（可选）',
    privacy_data_3: '灵性宝石和评论',
    privacy_data_4: '私信（加密）',
    privacy_data_5: '圣经书签和笔记',
    privacy_data_6: '应用偏好（语言、主题）',
    privacy_data_7: '通知偏好',
    privacy_advantages_title: '消息安全',
    security_auth_title: '认证安全',
    security_username_only: '仅用户名注册',
    security_username_only_desc: '无需电子邮件。最大化隐私。',
    security_encryption_rest: '静态加密 (AES-256-GCM)',
    security_encryption_rest_desc: '所有消息在存储前加密。',
    security_e2e: '端到端加密 (X25519 + AES-256-GCM)',
    security_e2e_desc: '消息用接收者的公钥加密。',
    security_rate_limit: '速率限制',
    security_rate_limit_desc: '每分钟限10条消息。',
    security_xss: 'XSS防护',
    security_xss_desc: '所有输入均经过净化处理。',
    security_input_validation: '输入验证',
    security_input_validation_desc: '所有内容均有长度限制并经过净化。',
    security_expiration: '消息过期',
    security_expiration_desc: '消息30天后自动删除。',
    security_https: '仅HTTPS',
    security_https_desc: '所有传输均TLS/SSL加密。',
    security_ddos: 'DDoS防护',
    security_ddos_desc: '多层保护：80请求/分钟时减速，120请求/分钟时封锁，300请求/分钟时自动封禁。重型端点限制为10请求/分钟。',
    security_password: '安全密码存储',
    security_password_desc: '密码使用bcrypt哈希。',
    security_jwt: 'JWT认证',
    security_jwt_desc: '基于令牌的认证，72小时过期。',
    security_notifications_title: '推送通知',
    security_notif_browser: '浏览器通知',
    security_notif_browser_desc: '为新消息启用推送通知。',
    security_notif_sound: '声音和振动',
    security_notif_sound_desc: '移动设备上的温和提示音和振动。',
    security_notif_data: '通知数据',
    security_notif_data_desc: '通知不包含消息内容。',
    privacy_limitations_title: '安全限制',
    limitation_server: '服务器访问',
    limitation_server_desc: '管理员理论上可以解密消息。',
    limitation_metadata: '元数据可见',
    limitation_metadata_desc: '我们可以看到谁发给谁，但看不到内容。',
    limitation_backup: '数据库备份',
    limitation_backup_desc: '备份可能包含加密消息。',
    limitation_device: '设备安全',
    limitation_device_desc: '被入侵的设备可能暴露消息。',
    limitation_social: '社会工程',
    limitation_social_desc: '请勿与任何人分享您的密码。',
    privacy_rights_title: '您的权利',
    privacy_rights_1: '访问您的数据',
    privacy_rights_2: '删除消息和内容',
    privacy_rights_3: '更新个人资料',
    privacy_rights_4: '禁用私信',
    privacy_rights_5: '请求删除账户',
    privacy_rights_6: '控制通知权限',
    privacy_retention_title: '数据保留',
    privacy_retention_content: '消息30天后删除。通知保留至已读。',
    privacy_third_party_title: '第三方服务',
    privacy_third_party_1: 'Microsoft Azure翻译（可选）',
    privacy_third_party_2: 'JW.org（圣经内容）',
    privacy_third_party_3: 'PayPal（捐赠）',
    privacy_third_party_note: '我们不出售您的数据。',
    security_enabled: '增强安全已启用',
    security_badge_desc: 'AES-256 + RSA-2048 + XSS防护',
    privacy_last_updated: '最后更新',
    privacy_contact: '有疑问？使用"建议修改"按钮。',
  },
  pa: {
    app_name: 'ਅਧਿਆਤਮਿਕ ਮੋਤੀ',
    home: 'ਘਰ',
    bible: 'ਬਾਈਬਲ',
    search: 'ਖੋਜ',
    search_placeholder: 'ਮੋਤੀ, ਬੁੱਕਮਾਰਕ, ਨੋਟਸ ਖੋਜੋ...',
    search_empty_message: 'ਕੀਵਰਡ ਜਾਂ ਆਇਤ ਸੰਦਰਭ ਦੁਆਰਾ ਮੋਤੀ ਖੋਜੋ',
    profile: 'ਪ੍ਰੋਫਾਈਲ',
    welcome_title: 'ਅਧਿਆਤਮਿਕ ਮੋਤੀ ਅਤੇ ਪ੍ਰਚਾਰ ਦੇ ਤੱਥ',
    welcome_subtitle: 'ਅਧਿਆਤਮਿਕ ਸੂਝ ਸਾਂਝੀ ਕਰੋ ਅਤੇ ਪਵਿੱਤਰ ਸ਼ਾਸਤਰ ਦੀ ਖੋਜ ਕਰੋ',
    enter_app: 'ਐਪ ਵਿੱਚ ਦਾਖਲ ਹੋਵੋ',
    select_language: 'ਭਾਸ਼ਾ ਚੁਣੋ',
    create_gem: 'ਇੱਕ ਮੋਤੀ ਸਾਂਝਾ ਕਰੋ',
    gem_placeholder: 'ਇੱਕ ਅਧਿਆਤਮਿਕ ਸੂਝ ਸਾਂਝੀ ਕਰੋ...',
    verse_ref_placeholder: 'ਆਇਤ ਹਵਾਲਾ (ਵਿਕਲਪਿਕ)',
    post: 'ਪੋਸਟ ਕਰੋ',
    sort_newest: 'ਨਵੀਨਤਮ',
    sort_oldest: 'ਸਭ ਤੋਂ ਪੁਰਾਣੇ',
    sort_most_liked: 'ਸਭ ਤੋਂ ਵੱਧ ਪਸੰਦ',
    liked_gems: 'ਪਸੰਦੀਦਾ ਮੋਤੀ',
    cancel: 'ਰੱਦ ਕਰੋ',
    like: 'ਪਸੰਦ',
    share: 'ਸਾਂਝਾ ਕਰੋ',
    report: 'ਰਿਪੋਰਟ',
    delete: 'ਮਿਟਾਓ',
    translate: 'ਅਨੁਵਾਦ',
    no_gems: 'ਅਜੇ ਕੋਈ ਮੋਤੀ ਨਹੀਂ। ਪਹਿਲੇ ਸਾਂਝਾ ਕਰਨ ਵਾਲੇ ਬਣੋ!',
    loading: 'ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...',
    settings: 'ਸੈਟਿੰਗਾਂ',
    donate: 'ਦਾਨ ਕਰੋ',
    about: 'ਬਾਰੇ',
    language: 'ਭਾਸ਼ਾ',
    about_nwt: 'ਨਵੀਂ ਦੁਨੀਆਂ ਅਨੁਵਾਦ ਬਾਰੇ',
    about_text: 'ਪਵਿੱਤਰ ਸ਼ਾਸਤਰ ਦਾ ਨਵੀਂ ਦੁਨੀਆਂ ਅਨੁਵਾਦ (2018 ਸੰਸ਼ੋਧਨ) ਆਪਣੀ ਸ਼ੁੱਧਤਾ, ਸਪੱਸ਼ਟਤਾ ਅਤੇ ਆਧੁਨਿਕ ਭਾਸ਼ਾ ਦੀ ਵਰਤੋਂ ਲਈ ਮਸ਼ਹੂਰ ਹੈ।',
    about_title: 'ਪਵਿੱਤਰ ਸ਼ਾਸਤਰ ਦਾ\nਨਵੀਂ ਦੁਨੀਆਂ ਅਨੁਵਾਦ',
    about_subtitle: '2018 ਸੰਸ਼ੋਧਨ',
    about_accuracy_title: 'ਸ਼ੁੱਧਤਾ ਅਤੇ ਵਫ਼ਾਦਾਰੀ',
    about_accuracy_text: 'ਨਵੀਂ ਦੁਨੀਆਂ ਅਨੁਵਾਦ ਸਮਰਪਿਤ ਵਿਦਵਾਨਾਂ ਦੀ ਇੱਕ ਕਮੇਟੀ ਦੁਆਰਾ ਤਿਆਰ ਕੀਤਾ ਗਿਆ ਸੀ ਜਿਨ੍ਹਾਂ ਨੇ ਮੂਲ ਇਬਰਾਨੀ, ਅਰਾਮੀ ਅਤੇ ਯੂਨਾਨੀ ਗ੍ਰੰਥਾਂ ਪ੍ਰਤੀ ਵਫ਼ਾਦਾਰੀ ਨੂੰ ਤਰਜੀਹ ਦਿੱਤੀ। ਕਈ ਅਨੁਵਾਦਾਂ ਦੇ ਉਲਟ ਜੋ ਪਾਠ ਦੀ ਸ਼ੁੱਧਤਾ ਤੋਂ ਵੱਧ ਪਰੰਪਰਾ ਦੀ ਪਾਲਣਾ ਕਰਦੇ ਹਨ, NWT ਲਗਾਤਾਰ ਪਰਮੇਸ਼ੁਰ ਦੇ ਨਿੱਜੀ ਨਾਮ, ਯਹੋਵਾਹ (YHWH) ਨੂੰ ਲਗਭਗ 7,000 ਥਾਵਾਂ ਤੇ ਪੇਸ਼ ਕਰਦਾ ਹੈ ਜਿੱਥੇ ਇਹ ਮੂਲ ਹੱਥ-ਲਿਖਤਾਂ ਵਿੱਚ ਦਿਖਾਈ ਦਿੱਤਾ ਸੀ।',
    about_clarity_title: 'ਸਪੱਸ਼ਟਤਾ ਅਤੇ ਆਧੁਨਿਕ ਭਾਸ਼ਾ',
    about_clarity_text: '2018 ਦੇ ਸੰਸ਼ੋਧਨ ਨੇ ਭਾਸ਼ਾ ਨੂੰ ਹੋਰ ਕੁਦਰਤੀ ਅਤੇ ਸਮਝਣ ਵਿੱਚ ਆਸਾਨ ਬਣਾਉਣ ਲਈ ਅਪਡੇਟ ਕੀਤਾ, ਸ਼ੁੱਧਤਾ ਬਣਾਈ ਰੱਖਦੇ ਹੋਏ। ਪੁਰਾਣੇ ਸ਼ਬਦਾਂ ਨੂੰ ਆਧੁਨਿਕ ਸਮਾਨ ਸ਼ਬਦਾਂ ਨਾਲ ਬਦਲ ਦਿੱਤਾ ਗਿਆ, ਮੂਲ ਪਾਠ ਦੀ ਡੂੰਘਾਈ ਅਤੇ ਸੁੰਦਰਤਾ ਨੂੰ ਕੁਰਬਾਨ ਕੀਤੇ ਬਿਨਾਂ ਸ਼ਾਸਤਰ ਨੂੰ ਸਮਕਾਲੀ ਪਾਠਕਾਂ ਲਈ ਹੋਰ ਪਹੁੰਚਯੋਗ ਬਣਾਇਆ।',
    about_gods_name_title: 'ਪਰਮੇਸ਼ੁਰ ਦੇ ਨਾਮ ਦੀ ਵਰਤੋਂ',
    about_gods_name_text: 'NWT ਦੀਆਂ ਸਭ ਤੋਂ ਵੱਖਰੀਆਂ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਵਿੱਚੋਂ ਇੱਕ ਬ੍ਰਹਮ ਨਾਮ ਯਹੋਵਾਹ ਦੀ ਲਗਾਤਾਰ ਵਰਤੋਂ ਹੈ। ਜਦੋਂ ਕਿ ਬਹੁਤ ਸਾਰੇ ਅਨੁਵਾਦਾਂ ਨੇ ਪਰਮੇਸ਼ੁਰ ਦੇ ਨਿੱਜੀ ਨਾਮ ਨੂੰ ਹਟਾ ਦਿੱਤਾ ਹੈ ਜਾਂ "ਪ੍ਰਭੂ" ਵਰਗੇ ਸਿਰਲੇਖਾਂ ਨਾਲ ਬਦਲ ਦਿੱਤਾ ਹੈ, NWT ਇਸਨੂੰ ਇਸਦੇ ਸਹੀ ਸਥਾਨ ਤੇ ਬਹਾਲ ਕਰਦਾ ਹੈ, ਪਾਠਕਾਂ ਨੂੰ ਬਾਈਬਲ ਦੇ ਲੇਖਕ ਨਾਲ ਵਧੇਰੇ ਨਿੱਜੀ ਸੰਬੰਧ ਵਿਕਸਿਤ ਕਰਨ ਦੀ ਆਗਿਆ ਦਿੰਦਾ ਹੈ।',
    about_languages_title: 'ਬਹੁਤ ਸਾਰੀਆਂ ਭਾਸ਼ਾਵਾਂ ਵਿੱਚ ਉਪਲਬਧ',
    about_languages_text: 'ਨਵੀਂ ਦੁਨੀਆਂ ਅਨੁਵਾਦ 200 ਤੋਂ ਵੱਧ ਭਾਸ਼ਾਵਾਂ ਵਿੱਚ ਪੂਰੀ ਤਰ੍ਹਾਂ ਜਾਂ ਅੰਸ਼ਕ ਤੌਰ ਤੇ ਉਪਲਬਧ ਹੈ, ਜੋ ਇਸਨੂੰ ਦੁਨੀਆ ਦੀਆਂ ਸਭ ਤੋਂ ਵੱਧ ਅਨੁਵਾਦਿਤ ਬਾਈਬਲਾਂ ਵਿੱਚੋਂ ਇੱਕ ਬਣਾਉਂਦਾ ਹੈ। ਇਹ ਐਪ 10 ਭਾਸ਼ਾਵਾਂ ਵਿੱਚ NWT ਤੱਕ ਪਹੁੰਚ ਪ੍ਰਦਾਨ ਕਰਦੀ ਹੈ, ਟੈਕਸਟ ਅਤੇ ਆਡੀਓ ਦੋਵੇਂ ਫਾਰਮੈਟਾਂ ਨਾਲ।',
    about_learn_more: 'ਹੋਰ ਜਾਣੋ',
    bible_navigation: 'ਬਾਈਬਲ ਨੈਵੀਗੇਸ਼ਨ',
    fullscreen: 'ਪੂਰੀ ਸਕ੍ਰੀਨ',
    exit_fullscreen: 'ਬਾਹਰ ਜਾਓ',
    translating: 'ਅਨੁਵਾਦ ਹੋ ਰਿਹਾ ਹੈ...',
    see_original: 'ਮੂਲ ਵੇਖੋ',
    see_translation: 'ਅਨੁਵਾਦ ਵੇਖੋ',
    translation_error: 'ਅਨੁਵਾਦ ਗਲਤੀ',
    search_bible: 'ਬਾਈਬਲ ਖੋਜੋ',
    searching: 'ਪੂਰੀ ਬਾਈਬਲ ਵਿੱਚ ਖੋਜ ਰਿਹਾ ਹੈ...',
    no_results: 'ਕੋਈ ਨਤੀਜੇ ਨਹੀਂ',
    results_found: 'ਨਤੀਜੇ ਮਿਲੇ',
    search_error: 'ਖੋਜ ਗਲਤੀ',
    add_bookmark: 'ਬੁੱਕਮਾਰਕ',
    add_note: 'ਨੋਟ',
    send_message: 'ਸੁਨੇਹਾ ਭੇਜੋ',
    messages: 'ਸੁਨੇਹੇ',
    new_message: 'ਨਵਾਂ ਸੁਨੇਹਾ',
    type_message: 'ਸੁਨੇਹਾ ਲਿਖੋ...',
    no_messages: 'ਕੋਈ ਸੁਨੇਹਾ ਨਹੀਂ',
    message_sent: 'ਸੁਨੇਹਾ ਭੇਜਿਆ ਗਿਆ',
    accept_messages: 'ਨਿੱਜੀ ਸੁਨੇਹੇ ਸਵੀਕਾਰ ਕਰੋ',
    messages_disabled: 'ਇਸ ਉਪਭੋਗਤਾ ਨੇ ਨਿੱਜੀ ਸੁਨੇਹੇ ਬੰਦ ਕਰ ਦਿੱਤੇ ਹਨ',
    notifications: 'ਸੂਚਨਾਵਾਂ',
    no_notifications: 'ਕੋਈ ਸੂਚਨਾ ਨਹੀਂ',
    mark_all_read: 'ਸਭ ਪੜ੍ਹੇ ਹੋਏ ਮਾਰਕ ਕਰੋ',
    messages_encrypted: 'ਸੁਨੇਹੇ ਐਂਡ-ਟੂ-ਐਂਡ ਐਨਕ੍ਰਿਪਟਡ ਹਨ',
    profile_photo: 'ਪ੍ਰੋਫਾਈਲ ਫੋਟੋ',
    change_photo: 'ਫੋਟੋ ਬਦਲੋ',
    remove_photo: 'ਫੋਟੋ ਹਟਾਓ',
    take_photo: 'ਫੋਟੋ ਖਿੱਚੋ',
    choose_from_gallery: 'ਗੈਲਰੀ ਤੋਂ ਚੁਣੋ',
    adjust_photo: 'ਫੋਟੋ ਸਮਾਯੋਜਿਤ ਕਰੋ',
    drag_to_position: 'ਸਥਿਤੀ ਲਈ ਤੀਰ ਵਰਤੋ',
    center: 'ਕੇਂਦਰ',
    guest_mode: 'ਮਹਿਮਾਨ ਮੋਡ',
    sign_in_prompt: 'ਆਪਣੇ ਅਨੁਭਵ ਨੂੰ ਅਨੁਕੂਲਿਤ ਕਰਨ ਲਈ ਸਾਈਨ ਇਨ ਕਰੋ',
    logout: 'ਲੌਗ ਆਊਟ',
    save_changes: 'ਤਬਦੀਲੀਆਂ ਸੰਭਾਲੋ',
    profile_updated: 'ਪ੍ਰੋਫਾਈਲ ਅੱਪਡੇਟ ਹੋ ਗਈ',
    photo_removed: 'ਫੋਟੋ ਹਟਾਈ ਗਈ',
    admin_access_granted: 'ਪ੍ਰਸ਼ਾਸਕ ਪਹੁੰਚ ਦਿੱਤੀ ਗਈ',
    login: 'ਲੌਗ ਇਨ',
    register: 'ਰਜਿਸਟਰ',
    login_to_post: 'ਪੋਸਟ ਕਰਨ ਲਈ ਲੌਗ ਇਨ ਕਰੋ',
    share_preaching: 'ਰਿਪੋਰਟ ਸਾਂਝੀ ਕਰੋ',
    preaching: 'ਪ੍ਰਚਾਰ',
    new_report: 'ਨਵੀਂ ਰਿਪੋਰਟ',
    no_reports: 'ਕੋਈ ਰਿਪੋਰਟ ਨਹੀਂ',
    report_posted: 'ਰਿਪੋਰਟ ਪ੍ਰਕਾਸ਼ਿਤ',
    report_deleted: 'ਰਿਪੋਰਟ ਹਟਾਈ ਗਈ',
    preaching_notes_placeholder: 'ਆਪਣਾ ਤਜਰਬਾ ਸਾਂਝਾ ਕਰੋ...',
    date: 'ਤਾਰੀਖ',
    all: 'ਸਭ',
    cat_presentoir: 'ਪ੍ਰਦਰਸ਼ਨੀ',
    cat_porte_a_porte: 'ਘਰ-ਘਰ',
    cat_rue: 'ਸੜਕ',
    cat_telephone: 'ਫ਼ੋਨ',
    cat_courrier: 'ਚਿੱਠੀ',
    cat_informel: 'ਗੈਰ-ਰਸਮੀ',
    cookie_title: 'ਕੁਕੀਜ਼ ਅਤੇ ਗੋਪਨੀਅਤਾ',
    cookie_message: 'ਅਸੀਂ ਇਸ਼ਤਿਹਾਰਾਂ ਲਈ ਕੁਕੀਜ਼ ਵਰਤਦੇ ਹਾਂ।',
    cookie_accept: 'ਸਵੀਕਾਰ ਕਰੋ',
    cookie_decline: 'ਸਿਰਫ਼ ਗੈਰ-ਵਿਅਕਤੀਗਤ',
    ad_loading_title: 'ਤੁਹਾਡਾ ਅਨੁਭਵ ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...',
    ad_loading_subtitle: 'ਤੁਹਾਡੀ ਭਾਸ਼ਾ ਵਿੱਚ ਸਮੱਗਰੀ ਤਿਆਰ ਕੀਤੀ ਜਾ ਰਹੀ ਹੈ',
    ad_revenue: 'ਇਸ਼ਤਿਹਾਰ ਆਮਦਨ (ਅੰਦਾਜ਼ਾ)',
    ad_revenue_history: 'ਮਹੀਨਾਵਾਰ ਇਸ਼ਤਿਹਾਰ ਆਮਦਨ',
    scroll_down_audio: 'ਆਡੀਓ ਪਲੇਅਰ ਦੇਖਣ ਲਈ ਹੇਠਾਂ ਸਕ੍ਰੋਲ ਕਰੋ',
    loading_bible: 'ਬਾਈਬਲ ਲੋਡ ਹੋ ਰਹੀ ਹੈ...',
    loading_first_time: 'ਪਹਿਲੀ ਵਾਰ ਲੋਡ ਹੋਣ ਵਿੱਚ ਕੁਝ ਸਕਿੰਟ ਲੱਗ ਸਕਦੇ ਹਨ',
    // Bible Audio
    audio_bible: 'ਆਡੀਓ ਬਾਈਬਲ',
    select_book: 'ਕਿਤਾਬ ਚੁਣੋ',
    choose_book: 'ਇੱਕ ਕਿਤਾਬ ਚੁਣੋ...',
    select_chapter: 'ਅਧਿਆਇ ਚੁਣੋ',
    choose_chapter: 'ਇੱਕ ਅਧਿਆਇ ਚੁਣੋ...',
    books_available: 'ਕਿਤਾਬਾਂ',
    audio_chapters: 'ਆਡੀਓ ਅਧਿਆਇ',
    bookmark_label_placeholder: 'ਲੇਬਲ (ਉਦਾ. ਉਤਪਤ 1:1)',
    verse_ref_placeholder: 'ਬਾਈਬਲ ਹਵਾਲਾ (ਵਿਕਲਪਿਕ)',
    note_placeholder: 'ਤੁਹਾਡਾ ਨੋਟ...',
    bible_not_available: 'ਬਾਈਬਲ ਉਪਲਬਧ ਨਹੀਂ',
    bible_not_available_desc: 'ਇਸ ਭਾਸ਼ਾ ਵਿੱਚ ਬਾਈਬਲ jw.org ਤੇ ਉਪਲਬਧ ਨਹੀਂ ਹੈ।',
    // Toast & UI messages
    bookmark_added: 'ਬੁੱਕਮਾਰਕ ਜੋੜਿਆ ਗਿਆ',
    bookmark_deleted: 'ਬੁੱਕਮਾਰਕ ਹਟਾਇਆ',
    note_saved: 'ਨੋਟ ਸੰਭਾਲਿਆ',
    note_deleted: 'ਨੋਟ ਹਟਾਇਆ',
    comment_added: 'ਟਿੱਪਣੀ ਜੋੜੀ ਗਈ',
    messages_enabled: 'ਸੁਨੇਹੇ ਸਮਰੱਥ',
    messages_disabled_toast: 'ਸੁਨੇਹੇ ਅਯੋਗ',
    password_changed: 'ਪਾਸਵਰਡ ਬਦਲਿਆ',
    change_password: 'ਪਾਸਵਰਡ ਬਦਲੋ',
    current_password: 'ਮੌਜੂਦਾ ਪਾਸਵਰਡ',
    new_password: 'ਨਵਾਂ ਪਾਸਵਰਡ (ਘੱਟੋ-ਘੱਟ 6 ਅੱਖਰ)',
    delete_account: 'ਖਾਤਾ ਮਿਟਾਓ',
    search_users: 'ਯੂਜ਼ਰ ਖੋਜੋ...',
    error: 'ਅਸਫ਼ਲ',
    comment_reported: 'ਅਸਫ਼ਲ',
    gem_deleted_admin: 'ਅਸਫ਼ਲ',
    password_change_failed: 'ਅਸਫ਼ਲ',
    account_deleted: 'ਅਸਫ਼ਲ',
    account_delete_failed: 'ਅਸਫ਼ਲ',
    auth_failed: 'ਅਸਫ਼ਲ',
    update_failed: 'ਅਸਫ਼ਲ',
    image_too_large: 'ਅਸਫ਼ਲ',
    invalid_password: 'ਅਸਫ਼ਲ',
    search_failed: 'ਅਸਫ਼ਲ',
    search_unavailable: 'ਅਸਫ਼ਲ',
    failed_load_gems: 'ਅਸਫ਼ਲ',
    failed_load_audio: 'ਅਸਫ਼ਲ',
    failed_load_comments: 'ਅਸਫ਼ਲ',
    failed_load_conversations: 'ਅਸਫ਼ਲ',
    failed_load_messages: 'ਅਸਫ਼ਲ',
    failed_load_reported: 'ਅਸਫ਼ਲ',
    failed_load_stats: 'ਅਸਫ਼ਲ',
    failed_add_bookmark: 'ਅਸਫ਼ਲ',
    failed_add_comment: 'ਅਸਫ਼ਲ',
    failed_delete: 'ਅਸਫ਼ਲ',
    failed_delete_gem: 'ਅਸਫ਼ਲ',
    failed_delete_bookmark: 'ਅਸਫ਼ਲ',
    failed_delete_note: 'ਅਸਫ਼ਲ',
    failed_save_note: 'ਅਸਫ਼ਲ',
    failed_update_like: 'ਅਸਫ਼ਲ',
    failed_update_photo: 'ਅਸਫ਼ਲ',
    failed_update_settings: 'ਅਸਫ਼ਲ',
    failed_remove_photo: 'ਅਸਫ਼ਲ',
    failed_report: 'ਅਸਫ਼ਲ',
    failed_report_comment: 'ਅਸਫ਼ਲ',
    failed_like_comment: 'ਅਸਫ਼ਲ',
    delete_account_warning: 'ਅਸਫ਼ਲ',
    confirm_password: 'ਅਸਫ਼ਲ',
    confirm_delete_account: 'ਅਸਫ਼ਲ',
    start_conversation_hint: 'ਅਸਫ਼ਲ',
    // Privacy & Security
    privacy_policy: 'ਗੋਪਨੀਅਤਾ ਅਤੇ ਸੁਰੱਖਿਆ',
    encrypted: 'ਐਨਕ੍ਰਿਪਟਡ',
    privacy_subtitle: 'ਸੁਰੱਖਿਆ ਅਤੇ ਡੇਟਾ ਸੁਰੱਖਿਆ',
    privacy_intro_title: 'ਤੁਹਾਡੀ ਗੋਪਨੀਅਤਾ ਮਹੱਤਵਪੂਰਨ ਹੈ',
    privacy_intro_content: 'Spiritual Gems ਤੁਹਾਡੀ ਗੋਪਨੀਅਤਾ ਦੀ ਰੱਖਿਆ ਲਈ ਵਚਨਬੱਧ ਹੈ।',
    privacy_data_title: 'ਇਕੱਠਾ ਕੀਤਾ ਡੇਟਾ',
    privacy_data_1: 'ਖਾਤਾ ਜਾਣਕਾਰੀ (ਯੂਜ਼ਰਨੇਮ, ਉਪਨਾਮ)',
    privacy_data_2: 'ਪ੍ਰੋਫਾਈਲ ਫੋਟੋ (ਵਿਕਲਪਿਕ)',
    privacy_data_3: 'ਅਧਿਆਤਮਿਕ ਰਤਨ ਅਤੇ ਟਿੱਪਣੀਆਂ',
    privacy_data_4: 'ਨਿੱਜੀ ਸੁਨੇਹੇ (ਐਨਕ੍ਰਿਪਟਡ)',
    privacy_data_5: 'ਬਾਈਬਲ ਬੁੱਕਮਾਰਕ ਅਤੇ ਨੋਟਸ',
    privacy_data_6: 'ਐਪ ਤਰਜੀਹਾਂ (ਭਾਸ਼ਾ, ਥੀਮ)',
    privacy_data_7: 'ਸੂਚਨਾ ਤਰਜੀਹਾਂ',
    privacy_advantages_title: 'ਸੁਨੇਹਾ ਸੁਰੱਖਿਆ',
    security_auth_title: 'ਪ੍ਰਮਾਣਿਕਤਾ ਸੁਰੱਖਿਆ',
    security_username_only: 'ਸਿਰਫ਼ ਯੂਜ਼ਰਨੇਮ ਰਜਿਸਟ੍ਰੇਸ਼ਨ',
    security_username_only_desc: 'ਕੋਈ ਈਮੇਲ ਲੋੜੀਂਦੀ ਨਹੀਂ। ਵੱਧ ਤੋਂ ਵੱਧ ਗੋਪਨੀਅਤਾ।',
    security_encryption_rest: 'ਆਰਾਮ ਵਿੱਚ ਐਨਕ੍ਰਿਪਸ਼ਨ (AES-256-GCM)',
    security_encryption_rest_desc: 'ਸਾਰੇ ਸੁਨੇਹੇ ਸਟੋਰੇਜ ਤੋਂ ਪਹਿਲਾਂ ਐਨਕ੍ਰਿਪਟ ਹੁੰਦੇ ਹਨ।',
    security_e2e: 'ਐਂਡ-ਟੂ-ਐਂਡ ਐਨਕ੍ਰਿਪਸ਼ਨ (X25519 + AES-256-GCM)',
    security_e2e_desc: 'ਸੁਨੇਹੇ ਪ੍ਰਾਪਤਕਰਤਾ ਦੀ ਪਬਲਿਕ ਕੀ ਨਾਲ ਐਨਕ੍ਰਿਪਟ ਹੁੰਦੇ ਹਨ।',
    security_rate_limit: 'ਰੇਟ ਸੀਮਾ',
    security_rate_limit_desc: 'ਪ੍ਰਤੀ ਮਿੰਟ 10 ਸੁਨੇਹੇ ਸੀਮਿਤ।',
    security_xss: 'XSS ਸੁਰੱਖਿਆ',
    security_xss_desc: 'ਸਾਰੇ ਇਨਪੁਟ ਸਾਫ਼ ਕੀਤੇ ਜਾਂਦੇ ਹਨ।',
    security_input_validation: 'ਇਨਪੁਟ ਪ੍ਰਮਾਣਿਕਤਾ',
    security_input_validation_desc: 'ਸਮੱਗਰੀ ਲੰਬਾਈ-ਸੀਮਿਤ ਅਤੇ ਸਾਫ਼।',
    security_expiration: 'ਸੁਨੇਹਾ ਮਿਆਦ',
    security_expiration_desc: 'ਸੁਨੇਹੇ 30 ਦਿਨਾਂ ਬਾਅਦ ਮਿਟ ਜਾਂਦੇ ਹਨ।',
    security_https: 'ਸਿਰਫ਼ HTTPS',
    security_https_desc: 'ਸਾਰੇ ਪ੍ਰਸਾਰਣ TLS/SSL ਐਨਕ੍ਰਿਪਟਡ।',
    security_ddos: 'DDoS ਸੁਰੱਖਿਆ',
    security_ddos_desc: 'ਬਹੁ-ਪੱਧਰੀ ਸੁਰੱਖਿਆ: 80 req/min ਤੇ ਹੌਲੀ, 120 req/min ਤੇ ਬਲਾਕ, 300 req/min ਤੇ ਆਟੋ-ਬੈਨ। ਭਾਰੀ ਐਂਡਪੁਆਇੰਟ 10 req/min ਤੱਕ ਸੀਮਿਤ।',
    security_password: 'ਸੁਰੱਖਿਅਤ ਪਾਸਵਰਡ ਸਟੋਰੇਜ',
    security_password_desc: 'ਪਾਸਵਰਡ bcrypt ਨਾਲ ਹੈਸ਼ ਕੀਤੇ ਜਾਂਦੇ ਹਨ।',
    security_jwt: 'JWT ਪ੍ਰਮਾਣਿਕਤਾ',
    security_jwt_desc: '72 ਘੰਟੇ ਦੀ ਮਿਆਦ ਨਾਲ ਟੋਕਨ ਪ੍ਰਮਾਣਿਕਤਾ।',
    security_notifications_title: 'ਪੁਸ਼ ਸੂਚਨਾਵਾਂ',
    security_notif_browser: 'ਬ੍ਰਾਊਜ਼ਰ ਸੂਚਨਾਵਾਂ',
    security_notif_browser_desc: 'ਨਵੇਂ ਸੁਨੇਹਿਆਂ ਲਈ ਪੁਸ਼ ਸੂਚਨਾਵਾਂ ਸਮਰੱਥ ਕਰੋ।',
    security_notif_sound: 'ਆਵਾਜ਼ ਅਤੇ ਵਾਈਬ੍ਰੇਸ਼ਨ',
    security_notif_sound_desc: 'ਮੋਬਾਈਲ ਤੇ ਹਲਕੀ ਆਵਾਜ਼ ਅਤੇ ਵਾਈਬ੍ਰੇਸ਼ਨ।',
    security_notif_data: 'ਸੂਚਨਾ ਡੇਟਾ',
    security_notif_data_desc: 'ਸੂਚਨਾਵਾਂ ਵਿੱਚ ਸੁਨੇਹੇ ਦੀ ਸਮੱਗਰੀ ਨਹੀਂ ਹੁੰਦੀ।',
    privacy_limitations_title: 'ਸੁਰੱਖਿਆ ਸੀਮਾਵਾਂ',
    limitation_server: 'ਸਰਵਰ ਐਕਸੈਸ',
    limitation_server_desc: 'ਪ੍ਰਸ਼ਾਸਕ ਸਿਧਾਂਤਕ ਤੌਰ ਤੇ ਸੁਨੇਹੇ ਡਿਕ੍ਰਿਪਟ ਕਰ ਸਕਦੇ ਹਨ।',
    limitation_metadata: 'ਮੈਟਾਡੇਟਾ ਦਿੱਖ',
    limitation_metadata_desc: 'ਅਸੀਂ ਦੇਖਦੇ ਹਾਂ ਕੌਣ ਕਿਸ ਨੂੰ ਭੇਜਦਾ ਹੈ, ਪਰ ਸਮੱਗਰੀ ਨਹੀਂ।',
    limitation_backup: 'ਬੈਕਅੱਪ',
    limitation_backup_desc: 'ਬੈਕਅੱਪ ਵਿੱਚ ਐਨਕ੍ਰਿਪਟਡ ਸੁਨੇਹੇ ਹੋ ਸਕਦੇ ਹਨ।',
    limitation_device: 'ਡਿਵਾਈਸ ਸੁਰੱਖਿਆ',
    limitation_device_desc: 'ਸਮਝੌਤਾ ਕੀਤਾ ਡਿਵਾਈਸ ਸੁਨੇਹੇ ਦਿਖਾ ਸਕਦਾ ਹੈ।',
    limitation_social: 'ਸੋਸ਼ਲ ਇੰਜੀਨੀਅਰਿੰਗ',
    limitation_social_desc: 'ਆਪਣਾ ਪਾਸਵਰਡ ਕਦੇ ਸਾਂਝਾ ਨਾ ਕਰੋ।',
    privacy_rights_title: 'ਤੁਹਾਡੇ ਅਧਿਕਾਰ',
    privacy_rights_1: 'ਆਪਣੇ ਡੇਟਾ ਤੱਕ ਪਹੁੰਚੋ',
    privacy_rights_2: 'ਸੁਨੇਹੇ ਅਤੇ ਸਮੱਗਰੀ ਮਿਟਾਓ',
    privacy_rights_3: 'ਪ੍ਰੋਫਾਈਲ ਅੱਪਡੇਟ ਕਰੋ',
    privacy_rights_4: 'ਨਿੱਜੀ ਸੁਨੇਹੇ ਅਯੋਗ ਕਰੋ',
    privacy_rights_5: 'ਖਾਤਾ ਮਿਟਾਉਣ ਦੀ ਬੇਨਤੀ ਕਰੋ',
    privacy_rights_6: 'ਸੂਚਨਾ ਅਨੁਮਤੀਆਂ ਨਿਯੰਤਰਿਤ ਕਰੋ',
    privacy_retention_title: 'ਡੇਟਾ ਸੰਭਾਲ',
    privacy_retention_content: 'ਸੁਨੇਹੇ 30 ਦਿਨਾਂ ਬਾਅਦ ਮਿਟ ਜਾਂਦੇ ਹਨ।',
    privacy_third_party_title: 'ਤੀਜੀ-ਧਿਰ ਸੇਵਾਵਾਂ',
    privacy_third_party_1: 'Microsoft Azure Translator (ਵਿਕਲਪਿਕ)',
    privacy_third_party_2: 'JW.org (ਬਾਈਬਲ ਸਮੱਗਰੀ)',
    privacy_third_party_3: 'PayPal (ਦਾਨ)',
    privacy_third_party_note: 'ਅਸੀਂ ਤੁਹਾਡਾ ਡੇਟਾ ਨਹੀਂ ਵੇਚਦੇ।',
    security_enabled: 'ਉੱਨਤ ਸੁਰੱਖਿਆ ਸਮਰੱਥ',
    security_badge_desc: 'AES-256 + RSA-2048 + XSS ਸੁਰੱਖਿਆ',
    privacy_last_updated: 'ਆਖਰੀ ਅੱਪਡੇਟ',
    privacy_contact: 'ਸਵਾਲ? "ਸੁਝਾਅ" ਬਟਨ ਵਰਤੋ।',
  },

  ru: {
    welcome_title: 'Духовные Жемчужины и Факты Проповеди',
    enter_app: 'Войти',
    app_name: 'Духовные Жемчужины',
    home: 'Главная',
    bible: 'Библия',
    search: 'Поиск',
    profile: 'Профиль',
    messages: 'Сообщения',
    settings: 'Настройки',
    language: 'Язык',
    theme: 'Тема',
    font_size: 'Размер шрифта',
    small: 'Мал.',
    medium: 'Сред.',
    large: 'Бол.',
    extra_large: 'Очень бол.',
    donate: 'Пожертвовать',
    suggest: 'Предложить изменение',
    about: 'О приложении',
    admin: 'Администратор',
    admin_password: 'Пароль администратора',
    loading: 'Загрузка...',
    cancel: 'Отмена',
    delete: 'Удалить',
    welcome_subtitle: 'Делитесь духовными мыслями и изучайте Священные Писания вместе',
    create_gem: 'Поделиться жемчужиной',
    no_gems: 'Жемчужин пока нет',
    gem_posted: 'Жемчужина опубликована',
    gem_reported: 'Жемчужина отмечена',
    gem_deleted: 'Жемчужина удалена',
    liked_gems: 'Понравившиеся',
    sort_newest: 'Новые',
    sort_oldest: 'Старые',
    sort_most_liked: 'Популярные',
    copied: 'Скопировано',
    login: 'Войти',
    register: 'Регистрация',
    login_to_post: 'Войдите, чтобы опубликовать',
    share_preaching: 'Поделиться отчётом',
    preaching: 'Проповедь',
    new_report: 'Новый отчёт',
    no_reports: 'Нет отчётов',
    report_posted: 'Отчёт опубликован',
    report_deleted: 'Отчёт удалён',
    preaching_notes_placeholder: 'Поделитесь опытом...',
    date: 'Дата',
    all: 'Все',
    cat_presentoir: 'Стенд',
    cat_porte_a_porte: 'Дом-в-дом',
    cat_rue: 'Улица',
    cat_telephone: 'Телефон',
    cat_courrier: 'Письмо',
    cat_informel: 'Неформально',
    cookie_title: 'Файлы cookie и конфиденциальность',
    cookie_message: 'Мы используем файлы cookie для рекламы и аналитики.',
    cookie_accept: 'Принять',
    cookie_decline: 'Только неперсонализированные',
    ad_loading_title: 'Загрузка вашего персонализированного опыта...',
    ad_loading_subtitle: 'Подготовка контента на вашем языке',
    ad_revenue: 'Доход от рекламы (оценка)',
    ad_revenue_history: 'Ежемесячный доход от рекламы',
    scroll_down_audio: 'Прокрутите вниз, чтобы увидеть аудиоплеер',
    loading_bible: 'Загрузка Библии...',
    loading_first_time: 'Первая загрузка может занять несколько секунд',
    login_success: 'Вход выполнен',
    register_success: 'Аккаунт создан',
    create_account: 'Создать аккаунт',
    username: 'Имя пользователя',
    password: 'Пароль',
    username_hint: 'Выберите уникальное имя (3-20 символов)',
    send_message: 'Отправить сообщение',
    new_message: 'Новое сообщение',
    type_message: 'Введите сообщение...',
    no_messages: 'Нет сообщений',
    message_sent: 'Сообщение отправлено',
    accept_messages: 'Принимать личные сообщения',
    messages_disabled: 'Этот пользователь отключил личные сообщения',
    login_to_message: 'Войдите, чтобы отправлять сообщения',
    cannot_message_self: 'Нельзя написать самому себе',
    notifications: 'Уведомления',
    no_notifications: 'Нет уведомлений',
    mark_all_read: 'Отметить все как прочитанные',
    messages_encrypted: 'Сообщения зашифрованы сквозным шифрованием',
    profile_photo: 'Фото профиля',
    change_photo: 'Изменить фото',
    remove_photo: 'Удалить фото',
    take_photo: 'Сделать фото',
    choose_from_gallery: 'Выбрать из галереи',
    adjust_photo: 'Настроить фото',
    drag_to_position: 'Используйте стрелки для позиционирования',
    center: 'По центру',
    guest_mode: 'Гостевой режим',
    sign_in_prompt: 'Войдите, чтобы настроить опыт',
    logout: 'Выйти',
    save_changes: 'Сохранить изменения',
    profile_updated: 'Профиль обновлён',
    photo_removed: 'Фото удалено',
    admin_access_granted: 'Доступ администратора предоставлен',
    edit: 'Редактировать',
    save: 'Сохранить',
    comment_updated: 'Комментарий обновлён',
    comment_deleted: 'Комментарий удалён',
    bookmarks: 'Закладки',
    notes: 'Заметки',
    add_bookmark: 'Закладка',
    add_note: 'Заметка',
    privacy_policy: 'Конфиденциальность и безопасность',
    encrypted: 'Зашифровано',
    privacy_subtitle: 'Безопасность и защита данных',
    privacy_intro_title: 'Ваша конфиденциальность важна',
    privacy_intro_content: 'Духовные Жемчужины стремится защитить вашу конфиденциальность и личные данные.',
    privacy_data_title: 'Собираемые данные',
    privacy_data_1: 'Данные аккаунта (имя пользователя, псевдоним)',
    privacy_data_2: 'Фото профиля (необязательно)',
    privacy_data_3: 'Духовные жемчужины и комментарии',
    privacy_data_4: 'Личные сообщения (зашифрованы)',
    privacy_data_5: 'Закладки и заметки Библии',
    privacy_data_6: 'Настройки приложения (язык, тема)',
    privacy_data_7: 'Настройки уведомлений',
    privacy_advantages_title: 'Безопасность сообщений',
    security_auth_title: 'Безопасность аутентификации',
    security_username_only: 'Регистрация только по имени пользователя',
    security_username_only_desc: 'Email не требуется. Максимальная конфиденциальность.',
    security_encryption_rest: 'Шифрование при хранении (AES-256-GCM)',
    security_encryption_rest_desc: 'Все сообщения шифруются перед сохранением.',
    security_e2e: 'Сквозное шифрование (X25519 + NaCl)',
    security_e2e_desc: 'Сообщения шифруются в вашем браузере. Сервер не может их прочитать.',
    security_zero_knowledge: 'Архитектура нулевого знания',
    security_zero_knowledge_desc: 'Ваш приватный ключ создаётся и хранится исключительно в вашем браузере.',
    security_rate_limit: 'Ограничение частоты',
    security_rate_limit_desc: 'Максимум 10 сообщений в минуту.',
    security_xss: 'Защита от XSS',
    security_xss_desc: 'Весь пользовательский ввод очищается.',
    security_input_validation: 'Проверка ввода',
    security_input_validation_desc: 'Контент ограничен по длине и очищен.',
    security_expiration: 'Срок действия сообщений',
    security_expiration_desc: 'Сообщения автоматически удаляются через 30 дней.',
    security_https: 'Только HTTPS',
    security_https_desc: 'Все передачи зашифрованы через TLS/SSL.',
    security_ddos: 'Защита от DDoS',
    security_ddos_desc: 'Многоуровневая защита: замедление с 80 запросов/мин, блокировка с 120 запросов/мин, автобан с 300 запросов/мин. Тяжёлые эндпоинты ограничены до 10 запросов/мин.',
    security_password: 'Безопасное хранение паролей (Argon2id)',
    security_password_desc: 'Все пароли хешируются с помощью Argon2id.',
    security_jwt: 'Аутентификация JWT',
    security_jwt_desc: 'Аутентификация на основе токенов с истечением через 72 часа.',
    security_pfs: 'Совершенная прямая секретность (PFS)',
    security_pfs_desc: 'Каждое сообщение использует уникальный эфемерный ключ.',
    security_key_separation: 'Хранение ключей на стороне клиента',
    security_key_separation_desc: 'Приватные ключи хранятся в вашем браузере, а не на сервере.',
    security_argon2: 'Хеширование Argon2id',
    security_argon2_desc: 'Пароли защищены Argon2id, устойчивым к атакам GPU.',
    security_secure_translation: 'Безопасный перевод',
    security_secure_translation_desc: 'Текст существует только в оперативной памяти сервера.',
    security_notifications_title: 'Push-уведомления',
    security_notif_browser: 'Уведомления браузера',
    security_notif_browser_desc: 'Включите push-уведомления для новых сообщений.',
    security_notif_sound: 'Звуки и вибрация',
    security_notif_sound_desc: 'Мягкий звук и вибрация на мобильных устройствах.',
    security_notif_data: 'Данные уведомлений',
    security_notif_data_desc: 'Уведомления не содержат содержимого сообщений.',
    privacy_limitations_title: 'Ограничения безопасности',
    limitation_server: 'Перевод требует временного открытого текста',
    limitation_server_desc: 'Для перевода клиент отправляет расшифрованный текст временно (только в RAM).',
    limitation_metadata: 'Видимость метаданных',
    limitation_metadata_desc: 'Мы видим кто кому пишет, но не содержание.',
    limitation_backup: 'Резервные копии',
    limitation_backup_desc: 'Копии могут содержать зашифрованные сообщения.',
    limitation_device: 'Безопасность устройства',
    limitation_device_desc: 'Скомпрометированное устройство может раскрыть сообщения.',
    limitation_social: 'Социальная инженерия',
    limitation_social_desc: 'Никогда не делитесь своим паролем.',
    privacy_rights_title: 'Ваши права',
    privacy_rights_1: 'Доступ к вашим данным',
    privacy_rights_2: 'Удаление сообщений и контента',
    privacy_rights_3: 'Обновление профиля',
    privacy_rights_4: 'Отключение личных сообщений',
    privacy_rights_5: 'Запрос на удаление аккаунта',
    privacy_rights_6: 'Управление разрешениями уведомлений',
    privacy_retention_title: 'Хранение данных',
    privacy_retention_content: 'Сообщения удаляются через 30 дней. Уведомления хранятся до прочтения.',
    privacy_third_party_title: 'Сторонние сервисы',
    privacy_third_party_1: 'Microsoft Azure Translator (необязательно)',
    privacy_third_party_2: 'JW.org (библейский контент)',
    privacy_third_party_3: 'PayPal (пожертвования)',
    privacy_third_party_note: 'Пожертвования обрабатываются через PayPal. Мы не видим ваши финансовые данные.',
    security_enabled: 'Архитектура нулевого знания',
    security_badge_desc: 'X25519 + PFS + AES-256-GCM + Argon2id',
    security_at_a_glance: 'Безопасность в двух словах',
    glance_no_email: 'Email не требуется',
    glance_no_email_desc: 'Полная конфиденциальность — только имя пользователя',
    glance_encryption: 'Шифрование нулевого знания',
    glance_encryption_desc: 'X25519 + NaCl — ключи в вашем браузере',
    glance_auto_delete: 'Автоудаление',
    glance_auto_delete_desc: 'Сообщения исчезают через 30 дней',
    privacy_last_updated: 'Последнее обновление',
    privacy_contact: 'Вопросы? Используйте «Предложить изменение».',
    bookmark_added: 'Закладка добавлена',
    bookmark_deleted: 'Закладка удалена',
    note_saved: 'Заметка сохранена',
    note_deleted: 'Заметка удалена',
    comment_added: 'Комментарий добавлен',
    comment_reported: 'Комментарий отмечен',
    gem_deleted_admin: 'Жемчужина удалена администратором',
    messages_enabled: 'Сообщения включены',
    messages_disabled_toast: 'Сообщения отключены',
    password_changed: 'Пароль изменён',
    password_change_failed: 'Ошибка смены пароля',
    account_deleted: 'Аккаунт удалён',
    account_delete_failed: 'Ошибка удаления аккаунта',
    auth_failed: 'Ошибка аутентификации',
    update_failed: 'Ошибка обновления',
    image_too_large: 'Изображение должно быть меньше 2МБ',
    invalid_password: 'Неверный пароль',
    search_failed: 'Ошибка поиска',
    search_unavailable: 'Поиск недоступен',
    error: 'Ошибка',
    failed_load_gems: 'Ошибка загрузки',
    failed_load_audio: 'Ошибка загрузки аудио',
    failed_load_comments: 'Ошибка загрузки комментариев',
    failed_load_conversations: 'Ошибка загрузки бесед',
    failed_load_messages: 'Ошибка загрузки сообщений',
    failed_load_reported: 'Ошибка загрузки',
    failed_load_stats: 'Ошибка загрузки статистики',
    failed_add_bookmark: 'Ошибка добавления закладки',
    failed_add_comment: 'Ошибка добавления',
    failed_delete: 'Ошибка удаления',
    failed_delete_gem: 'Ошибка удаления',
    failed_delete_bookmark: 'Ошибка удаления',
    failed_delete_note: 'Ошибка удаления',
    failed_save_note: 'Ошибка сохранения',
    failed_update_like: 'Ошибка',
    failed_update_photo: 'Ошибка обновления фото',
    failed_update_settings: 'Ошибка настроек',
    failed_remove_photo: 'Ошибка удаления фото',
    failed_report: 'Ошибка отправки',
    failed_report_comment: 'Ошибка отправки',
    failed_like_comment: 'Ошибка',
    change_password: 'Изменить пароль',
    current_password: 'Текущий пароль',
    new_password: 'Новый пароль (мин. 6 символов)',
    delete_account: 'Удалить аккаунт',
    delete_account_warning: 'Это навсегда удалит ваш аккаунт и все данные.',
    confirm_password: 'Введите пароль для подтверждения',
    confirm_delete_account: 'Удалить аккаунт навсегда',
    search_users: 'Поиск пользователей...',
    start_conversation_hint: 'Нажмите на имя пользователя, чтобы начать беседу',
    admin_stats: 'Статистика',
    visitors_this_month: 'Посетители за месяц',
    chars_translated: 'Символов переведено',
    requests: 'запросов',
    visitor_history: 'Посетители по месяцам',
    translation_history: 'Перевод по месяцам (символы)',
    reported_gems: 'Отмеченные жемчужины',
    reported_comments: 'Комментарии',
    audio_bible: 'Аудио Библия',
    select_book: 'Выбрать книгу',
    choose_book: 'Выберите книгу...',
    select_chapter: 'Выбрать главу',
    choose_chapter: 'Выберите главу...',
    books_available: 'книг',
    audio_chapters: 'аудио глав',
    bookmark_label_placeholder: 'Метка (напр. Бытие 1:1)',
    verse_ref_placeholder: 'Ссылка на стих (необязательно)',
    note_placeholder: 'Ваша заметка...',
    bible_not_available: 'Библия недоступна',
    bible_not_available_desc: 'Библия на этом языке ещё не доступна на jw.org.',
    bible_reader: 'Чтение Библии',
    fullscreen: 'Полный экран',
    audio: 'Аудио',
    search_placeholder: 'Введите слово или фразу...',
  },
};

// Fill in missing keys from English for incomplete translations
const enKeys = Object.keys(translations.en);
Object.keys(translations).forEach(lang => {
  if (lang !== 'en') {
    enKeys.forEach(key => {
      if (!translations[lang][key]) {
        translations[lang][key] = translations.en[key];
      }
    });
  }
});

export default translations;
